var _path, _path2, _path3, _path4, _polygon, _polygon2, _polygon3, _path5, _path6, _polygon4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomepageimg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M392,77.58a43.91,43.91,0,1,1-49.76-37A43.85,43.85,0,0,1,392,77.58Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.63,79.08a33.46,33.46,0,1,1-37.92-28.23A33.42,33.42,0,0,1,381.63,79.08Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.47,78.05c-.2,0-.55-1.4-1.45-3.86a35.41,35.41,0,0,0-5.3-9.6,34.77,34.77,0,0,0-5.25-5.38,33.92,33.92,0,0,0-7.32-4.52,33,33,0,0,0-9.1-2.62,33,33,0,0,0-5-.29,36.05,36.05,0,0,0-5.14.5,35.59,35.59,0,0,0-5,1.3,33.27,33.27,0,0,0-4.6,2,30.21,30.21,0,0,0-4.1,2.57,30.73,30.73,0,0,0-3.54,3,33.46,33.46,0,0,0-5.31,6.76,34.72,34.72,0,0,0-3.09,6.86,35.6,35.6,0,0,0-1.66,10.83c0,2.62.16,4.09,0,4.12s-.64-1.38-1-4.06a31.17,31.17,0,0,1,.92-11.39A33.5,33.5,0,0,1,324,59.51a31.56,31.56,0,0,1,3.75-3.31,32.2,32.2,0,0,1,4.38-2.83,32.89,32.89,0,0,1,4.95-2.19,36.78,36.78,0,0,1,5.39-1.42,36.16,36.16,0,0,1,5.55-.52,34.43,34.43,0,0,1,5.4.35,33.88,33.88,0,0,1,9.74,3,34,34,0,0,1,7.69,5,33.62,33.62,0,0,1,5.34,5.93A31.08,31.08,0,0,1,381,73.9C381.61,76.52,381.62,78,381.47,78.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.13,103.1l.92,5.76-5.14.82-.89-5.6c-5.14.51-10.28-.3-13.46-2.06l1.82-6.72a21.1,21.1,0,0,0,10.56,2l-1.37-8.59c-5.93-.47-12.61-1.35-13.79-8.7-.87-5.45,2.34-10.76,10.31-13l-.91-5.71,5.14-.82.9,5.6a23.46,23.46,0,0,1,10.93,1.47l-1.56,6.73a21.17,21.17,0,0,0-8.29-1.41l1.4,8.73c5.92.43,12.49,1.32,13.65,8.57C366.21,95.59,363,100.84,355.13,103.1Zm-8.77-21.89-1.17-7.3c-2.63,1.06-3.47,2.72-3.2,4.42S344,80.85,346.36,81.21Zm10.82,11c-.29-1.8-1.94-2.53-4.27-3l1.14,7.09C356.53,95.34,357.44,93.83,357.18,92.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.45,58.36a28.74,28.74,0,1,1-26.67-30.62A28.72,28.72,0,0,1,491.45,58.36Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.62,57.88A21.9,21.9,0,1,1,464.3,34.55,21.86,21.86,0,0,1,484.62,57.88Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.67,57.19a12.4,12.4,0,0,1-.4-2.67,23,23,0,0,0-2-6.87,22.63,22.63,0,0,0-2.61-4.17,21.89,21.89,0,0,0-4.05-3.91,21.13,21.13,0,0,0-5.45-2.94,20.77,20.77,0,0,0-3.16-.88,23.36,23.36,0,0,0-3.36-.4,22.33,22.33,0,0,0-3.38.14,21.32,21.32,0,0,0-3.22.63,21.8,21.8,0,0,0-5.66,2.51A22,22,0,0,0,447,42.22a22.52,22.52,0,0,0-2.93,4,23.18,23.18,0,0,0-2.57,6.69,13,13,0,0,1-.59,2.63,6.21,6.21,0,0,1,0-2.73A20.14,20.14,0,0,1,443,45.61,22.67,22.67,0,0,1,446,41.29a22.62,22.62,0,0,1,7.38-5.55,23.45,23.45,0,0,1,3.2-1.2,23.19,23.19,0,0,1,3.47-.71,24.41,24.41,0,0,1,3.64-.15,23.72,23.72,0,0,1,3.62.43,22.32,22.32,0,0,1,3.41,1,21.84,21.84,0,0,1,3.09,1.44,21.18,21.18,0,0,1,2.73,1.81,22.39,22.39,0,0,1,4.21,4.29,22.83,22.83,0,0,1,2.6,4.54,20.11,20.11,0,0,1,1.61,7.3A6.61,6.61,0,0,1,484.67,57.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.33,69.55l-.21,3.81-3.4-.19.21-3.71a16.1,16.1,0,0,1-8.32-3.19l2.1-4A13.86,13.86,0,0,0,461.18,65l.31-5.68c-3.72-1.13-7.87-2.62-7.6-7.49.2-3.6,3-6.55,8.4-6.86l.21-3.78,3.4.19-.21,3.71a15.25,15.25,0,0,1,6.79,2.46l-1.93,4.09a13.86,13.86,0,0,0-5.11-2.06l-.32,5.78c3.73,1.09,7.81,2.58,7.54,7.38C472.46,66.28,469.71,69.2,464.33,69.55Zm-2.56-15.22L462,49.5c-1.83.31-2.6,1.25-2.66,2.38S460.3,53.77,461.77,54.33Zm5.39,8.52c.07-1.19-.88-1.89-2.32-2.48l-.26,4.69C466.3,64.78,467.1,63.94,467.16,62.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.68,72.34a44.75,44.75,0,1,1,71.65,46.13h0a44.74,44.74,0,0,1-71.65-46.13Zm83.55,22.34a41.72,41.72,0,1,0-13.8,21.47A41.73,41.73,0,0,0,186.23,94.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.72,70.11a44.75,44.75,0,1,1,71.65,46.14h0a44.75,44.75,0,0,1-71.65-46.14Zm83.55,22.35a41.72,41.72,0,1,0-13.8,21.47A41.73,41.73,0,0,0,185.27,92.46Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.26,152.06l-.71-.78c-1.52-1.67-2-3.72-1-4.58l42.92-39c.21-.19.66,0,1,.33l5,5.47c.34.37.44.83.23,1l-42.92,39C71.77,154.38,69.77,153.73,68.26,152.06Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.19,51a6.63,6.63,0,0,1,1.12-.72,11.26,11.26,0,0,1,1.38-.74,18.87,18.87,0,0,1,1.88-.87A33.13,33.13,0,0,1,138.69,47a38.48,38.48,0,0,1,6.54-.91,37.54,37.54,0,0,1,6.59.35,32.2,32.2,0,0,1,5.25,1.22c.74.21,1.38.48,2,.7a12.12,12.12,0,0,1,1.43.62,6.45,6.45,0,0,1,1.17.62c0,.1-1.74-.74-4.66-1.59a37.89,37.89,0,0,0-5.21-1.1,36.47,36.47,0,0,0-12.95.56A36.92,36.92,0,0,0,133.7,49C130.87,50.1,129.25,51.08,129.19,51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.5,54.34a6.9,6.9,0,0,1-2.36-1.17,7,7,0,0,1-2.08-1.62,6.87,6.87,0,0,1,2.36,1.18C168.65,53.5,169.58,54.22,169.5,54.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.42,152.6l-41.11-20a5.72,5.72,0,0,1-2.64-7.65L640.38,68A5.72,5.72,0,0,1,648,65.38l26.08,12.7,10,30.63L664.07,150A5.73,5.73,0,0,1,656.42,152.6Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.11,78.08l-7.8,16a5.33,5.33,0,0,0,2.45,7.12l15.4,7.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.18,91.76c-.1.21-4.44-1.7-9.69-4.26s-9.43-4.8-9.33-5,4.43,1.7,9.69,4.26S663.28,91.55,663.18,91.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.05,106.8c-.1.2-7.19-3-15.83-7.25s-15.57-7.79-15.47-8,7.18,3,15.83,7.25S671.15,106.59,671.05,106.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.19,115.73c-.1.21-7.82-3.34-17.24-7.93s-17-8.48-16.89-8.69,7.82,3.35,17.25,7.94S670.29,115.53,670.19,115.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.72,122.87c-.1.2-7.83-3.35-17.25-7.94s-17-8.48-16.88-8.68,7.82,3.35,17.24,7.94S666.82,122.66,666.72,122.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.24,130c-.1.21-7.82-3.35-17.24-7.93s-17-8.48-16.89-8.69,7.82,3.35,17.25,7.94S663.34,129.8,663.24,130Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.77,137.14c-.1.2-7.82-3.35-17.25-7.94s-17-8.48-16.88-8.68,7.82,3.35,17.25,7.94S659.87,136.93,659.77,137.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.07,197.91a4.58,4.58,0,0,1-3.43-5.49l8.93-38.78a3.79,3.79,0,0,1,4.64-2.69l3.64.84a4,4,0,0,0,4-1.28l1.14-1.41a4,4,0,0,1,3.95-1.28l17.31,4a4,4,0,0,1,2.88,2.51l.54,1.54a4,4,0,0,0,2.88,2.51l22.06,5.09a3.78,3.78,0,0,1,3,4.45l-9.13,39.66a4.58,4.58,0,0,1-5.49,3.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.22,157.88l-14-3.26-.71-2.63a4.94,4.94,0,0,0-3.72-3.47L160,145.36a4.4,4.4,0,0,0-5.38,3.12l-.36,1.6-9.7,42.11a5,5,0,0,0,3.94,5.86l55.73,12.83a5,5,0,0,0,6.11-3.55l9.16-39.77a3.29,3.29,0,0,0-2.48-3.95Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.08,
    y: 172.45,
    width: 34.04,
    height: 14.32,
    transform: "translate(44.98 -36.51) rotate(12.97)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.76,181.43c0,.12-5.15-1-11.44-2.4s-11.38-2.73-11.35-2.85,5.16.95,11.45,2.4S194.79,181.31,194.76,181.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.08,184.4c0,.13-5.16-1-11.45-2.4s-11.37-2.72-11.34-2.85,5.15,1,11.45,2.41S194.11,184.28,194.08,184.4Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M697.19,474.18c0,.14-149.64.26-334.17.26s-334.21-.12-334.21-.26,149.6-.26,334.21-.26S697.19,474,697.19,474.18Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coins--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M714.28,184.67a21.21,21.21,0,1,1-17.8-24.14A21.2,21.2,0,0,1,714.28,184.67Z",
    style: {
      fill: "#09AD58"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M696.48,160.53a21.22,21.22,0,0,0-24.14,17.81s14.64,2.88,19.08-2.52S696.48,160.53,696.48,160.53Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M709,183.53a16.12,16.12,0,1,1-13.53-18.35A16.12,16.12,0,0,1,709,183.53Z",
    style: {
      fill: "#09AD58"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M709,183.53a16.12,16.12,0,1,1-13.53-18.35A16.12,16.12,0,0,1,709,183.53Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M709.32,184.26A15.9,15.9,0,1,1,696,166.16,15.91,15.91,0,0,1,709.32,184.26Z",
    style: {
      fill: "#09AD58"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M709.32,184.26A15.9,15.9,0,1,1,696,166.16,15.91,15.91,0,0,1,709.32,184.26Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M694.43,180.62l.6-4h0a8.14,8.14,0,0,1,2.06.88,6.69,6.69,0,0,1,.9.78l.07-.12.84-1.35.2-.31-.61-.87-.36.11a7.56,7.56,0,0,0-2.79-1.28l.33-2.22-.6-.66-.09.56-.94-.14-.34,2.25c-3.16-.17-4.9,1.38-5.21,3.41-.41,2.77,1.85,3.85,4,4.72l-.6,4a7.72,7.72,0,0,1-3.76-2.12l-1.2,1.88a8.82,8.82,0,0,0,4.63,2.39l-.25,1.67-.78-.1.7.64,1.63.25.34-2.23c3.18.15,4.94-1.38,5.24-3.41C698.86,182.55,696.56,181.49,694.43,180.62Zm-1.58-.67c-1.1-.51-1.89-1.08-1.75-2s.84-1.5,2.29-1.51Zm2.18-3.36Zm-1.5,10,.53-3.53c1.15.52,2,1.11,1.81,2.08S695,186.56,693.53,186.56Z",
    style: {
      fill: "#09AD58"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M694.43,180.62l.6-4h0a8.14,8.14,0,0,1,2.06.88,6.69,6.69,0,0,1,.9.78l.07-.12.84-1.35.2-.31-.61-.87-.36.11a7.56,7.56,0,0,0-2.79-1.28l.33-2.22-.6-.66-.09.56-.94-.14-.34,2.25c-3.16-.17-4.9,1.38-5.21,3.41-.41,2.77,1.85,3.85,4,4.72l-.6,4a7.72,7.72,0,0,1-3.76-2.12l-1.2,1.88a8.82,8.82,0,0,0,4.63,2.39l-.25,1.67-.78-.1.7.64,1.63.25.34-2.23c3.18.15,4.94-1.38,5.24-3.41C698.86,182.55,696.56,181.49,694.43,180.62Zm-1.58-.67c-1.1-.51-1.89-1.08-1.75-2s.84-1.5,2.29-1.51Zm2.18-3.36Zm-1.5,10,.53-3.53c1.15.52,2,1.11,1.81,2.08S695,186.56,693.53,186.56Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M692.61,188.08l-.34,2.23-1.63-.24.33-2.22a8.78,8.78,0,0,1-4.63-2.39l1.2-1.88a7.68,7.68,0,0,0,3.75,2.12l.61-4c-2.14-.87-4.4-2-4-4.72.31-2,2.05-3.58,5.2-3.41l.34-2.25,1.64.24-.33,2.22a8.61,8.61,0,0,1,3.86,1.82l-1.12,1.89a8.51,8.51,0,0,0-3.07-1.56l-.61,4c2.13.87,4.44,1.93,4,4.7C697.55,186.7,695.79,188.23,692.61,188.08Zm-.35-8.78.54-3.55c-1.45,0-2.16.63-2.29,1.51S691.16,178.79,692.26,179.3Zm3,5.17c.15-1-.66-1.57-1.8-2.09l-.53,3.53C694.42,185.91,695.14,185.32,695.27,184.47Z",
    style: {
      fill: "#09AD58"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689,178.87a1.31,1.31,0,0,1-.39-.53,2.51,2.51,0,0,1,.55-3,1.41,1.41,0,0,1,.56-.35s-.2.15-.48.43a2.7,2.7,0,0,0-.7,1.34,2.61,2.61,0,0,0,.17,1.5C688.89,178.66,689.05,178.85,689,178.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.51,173.3a1.61,1.61,0,0,1,0-.67,1.54,1.54,0,0,1,.18-.64,1.6,1.6,0,0,1,0,.67A1.54,1.54,0,0,1,693.51,173.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.18,196.17a10.29,10.29,0,1,1-11.78-8.55A10.3,10.3,0,0,1,652.18,196.17Z",
    style: {
      fill: "#09AD58"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M640.4,187.62a10.29,10.29,0,0,0-8.55,11.79s7.19-.82,8.45-4S640.4,187.62,640.4,187.62Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M649.56,196.42a7.83,7.83,0,1,1-9-6.49A7.83,7.83,0,0,1,649.56,196.42Z",
    style: {
      fill: "#09AD58"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M649.56,196.42a7.83,7.83,0,1,1-9-6.49A7.83,7.83,0,0,1,649.56,196.42Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M649.83,196.71A7.72,7.72,0,1,1,641,190.3,7.72,7.72,0,0,1,649.83,196.71Z",
    style: {
      fill: "#09AD58"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M649.83,196.71A7.72,7.72,0,1,1,641,190.3,7.72,7.72,0,0,1,649.83,196.71Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M642.4,197.22l-.31-2h0a4.09,4.09,0,0,1,1.08.11,2.9,2.9,0,0,1,.53.23l0-.07.19-.75,0-.17-.4-.31-.16.1a3.84,3.84,0,0,0-1.48-.18l-.17-1.07-.38-.22,0,.27-.46.07.17,1.09c-1.48.39-2.06,1.36-1.9,2.35.21,1.34,1.42,1.51,2.53,1.6l.31,1.93a3.66,3.66,0,0,1-2.05-.43l-.28,1.05a4.33,4.33,0,0,0,2.49.43l.13.81-.37.06.41.2.8-.13-.17-1.08c1.49-.4,2.08-1.36,1.92-2.35C644.74,197.46,643.51,197.31,642.4,197.22Zm-.83-.08c-.58-.08-1-.22-1.11-.69s.17-.82.84-1Zm.52-1.88Zm.77,4.84-.27-1.71c.6.07,1.06.22,1.14.7S643.55,199.88,642.86,200.1Z",
    style: {
      fill: "#09AD58"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M642.4,197.22l-.31-2h0a4.09,4.09,0,0,1,1.08.11,2.9,2.9,0,0,1,.53.23l0-.07.19-.75,0-.17-.4-.31-.16.1a3.84,3.84,0,0,0-1.48-.18l-.17-1.07-.38-.22,0,.27-.46.07.17,1.09c-1.48.39-2.06,1.36-1.9,2.35.21,1.34,1.42,1.51,2.53,1.6l.31,1.93a3.66,3.66,0,0,1-2.05-.43l-.28,1.05a4.33,4.33,0,0,0,2.49.43l.13.81-.37.06.41.2.8-.13-.17-1.08c1.49-.4,2.08-1.36,1.92-2.35C644.74,197.46,643.51,197.31,642.4,197.22Zm-.83-.08c-.58-.08-1-.22-1.11-.69s.17-.82.84-1Zm.52-1.88Zm.77,4.84-.27-1.71c.6.07,1.06.22,1.14.7S643.55,199.88,642.86,200.1Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M642.66,200.94l.17,1.08-.8.13-.17-1.08a4.26,4.26,0,0,1-2.49-.42l.28-1.05a3.74,3.74,0,0,0,2.05.43l-.31-1.94c-1.11-.09-2.32-.25-2.53-1.59-.16-1,.42-2,1.9-2.35l-.17-1.09.79-.13.17,1.08a4.23,4.23,0,0,1,2.06.27l-.24,1a4.08,4.08,0,0,0-1.65-.27L642,197c1.11.09,2.34.24,2.55,1.59C644.74,199.57,644.15,200.54,642.66,200.94Zm-1.46-4-.27-1.73c-.67.22-.9.61-.84,1S640.62,196.85,641.2,196.93Zm2.16,1.94c-.08-.47-.54-.63-1.14-.7l.27,1.71C643.18,199.66,643.42,199.29,643.36,198.87Z",
    style: {
      fill: "#09AD58"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.65,197.2s-.12,0-.26-.19a1.25,1.25,0,0,1-.34-.69,1.23,1.23,0,0,1,.16-.76,1,1,0,0,1,.2-.25s-.07.1-.16.27a1.34,1.34,0,0,0-.12.73,1.26,1.26,0,0,0,.3.67C639.55,197.12,639.65,197.19,639.65,197.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.9,194s-.06-.13-.09-.31a.65.65,0,0,1,0-.32.79.79,0,0,1,.09.31A.64.64,0,0,1,640.9,194Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--ring-binder--inject-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "224.58 98.74 218.31 135.44 218.31 474.18 523.28 474.18 523.28 452.65 224.58 98.74",
    style: {
      fill: "#09AD58"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.58,98.74H518a12.2,12.2,0,0,1,12.2,12.2v333.8a12.2,12.2,0,0,1-12.2,12.2H224.58a0,0,0,0,1,0,0V98.74A0,0,0,0,1,224.58,98.74Z",
    style: {
      fill: "#09AD58"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518,457.43h-294V98.24H518a12.71,12.71,0,0,1,12.69,12.7v333.8A12.7,12.7,0,0,1,518,457.43Zm-293-1H518a11.7,11.7,0,0,0,11.69-11.69V110.94A11.71,11.71,0,0,0,518,99.24h-293Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "497.23 108.99 514.16 137.22 514.16 446.31 250.32 443.68 235.88 428.74 497.23 108.99",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.88,
    y: 107.63,
    width: 261.35,
    height: 321.11,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.23,428.74c0-2-.09-130.13-.23-321.11l.23.23-261.33,0h0l.26-.26c0,118.79,0,229.27,0,321.11l-.21-.22,261.35.22L235.88,429h-.22v-.22c0-91.84,0-202.32,0-321.11v-.26h.28l261.33,0h.23v.23C497.33,298.61,497.23,426.71,497.23,428.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268,215.76c0,3.61-2.66,6.54-5.93,6.54s-5.93-2.93-5.93-6.54,2.65-6.53,5.93-6.53S268,212.16,268,215.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "224.58 261.86 235.88 261.86 235.85 252.13 224.58 252.13 224.58 261.86"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M230,183.41c-19.66,0-35.65,15.56-35.65,34.69s16.18,34.7,35.84,34.7h5.68l-.09-8.23-5.59.23c-15.65,0-28.58-12-28.58-26.7s12.73-26.69,28.39-26.69,28.39,12,28.39,26.69a3.65,3.65,0,1,0,7.26,0C265.66,199,249.66,183.41,230,183.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,183.41s.28,0,.84,0l2.48.1c1.09.1,2.42.31,4,.55a39.19,39.19,0,0,1,5.3,1.52,36.57,36.57,0,0,1,12.74,7.95l1.54,1.65c.26.28.53.55.78.84l.72.93c.47.64,1,1.25,1.44,1.92l1.32,2.1a35.64,35.64,0,0,1,3.87,9.83,33.69,33.69,0,0,1,.72,5.66,8.35,8.35,0,0,1-.11,3,4.12,4.12,0,0,1-1.91,2.41,3.58,3.58,0,0,1-3.13.15,4,4,0,0,1-2.15-2.36,5,5,0,0,1-.28-1.63l-.09-1.58a21.77,21.77,0,0,0-.4-3.18,26,26,0,0,0-5.85-11.85,29.85,29.85,0,0,0-8.27-6.48c-.53-.27-1.09-.5-1.64-.76a13.58,13.58,0,0,0-1.67-.68l-1.73-.59c-.58-.18-1.19-.3-1.78-.45a31.25,31.25,0,0,0-3.65-.63,30.51,30.51,0,0,0-7.51.2,32.43,32.43,0,0,0-3.75.78c-.61.18-1.21.41-1.83.61l-.91.32-.89.4a27.56,27.56,0,0,0-6.66,4.07,26.31,26.31,0,0,0-5.35,5.88,24.32,24.32,0,0,0-3.37,7.33,22.25,22.25,0,0,0-.87,8.13,23.43,23.43,0,0,0,1.86,8.07,27.58,27.58,0,0,0,13.42,13.95,28.32,28.32,0,0,0,9.17,2.72,32.64,32.64,0,0,0,4.7.23l4.67-.19h.27v.26q0,4.19.08,8.23v.25h-.25c-2.11,0-4.2,0-6.27,0l-3.11-.16-3.05-.46a37.64,37.64,0,0,1-11.23-4.09c-.84-.51-1.71-.95-2.5-1.52l-2.33-1.69-2.15-1.88a8.59,8.59,0,0,1-1-1l-1-1a35,35,0,0,1-6-9c-.41-.79-.65-1.64-1-2.44l-.46-1.22-.34-1.25c-.2-.83-.47-1.64-.62-2.47s-.26-1.67-.39-2.49a33.62,33.62,0,0,1,.19-9.58,31.54,31.54,0,0,1,1-4.44,18.27,18.27,0,0,1,.73-2.08c.27-.67.48-1.37.8-2a33.93,33.93,0,0,1,2-3.69c.36-.57.72-1.14,1.07-1.71s.8-1.05,1.19-1.57a35.44,35.44,0,0,1,10.41-9c.44-.25.86-.52,1.29-.74l1.31-.61a21.83,21.83,0,0,1,2.48-1.07l2.34-.82c.75-.22,1.48-.37,2.16-.55a26.67,26.67,0,0,1,3.68-.67c.53-.07,1-.17,1.48-.19l1.23-.05,1.66-.07H230l-.57.05-1.66.1-1.22.07c-.46,0-.94.14-1.48.21a28.61,28.61,0,0,0-3.65.71c-.68.18-1.4.34-2.15.57L217,186A21.71,21.71,0,0,0,214.5,187l-1.29.62c-.43.22-.84.49-1.28.74a35.34,35.34,0,0,0-10.28,9c-.39.51-.8,1-1.17,1.56l-1.06,1.69a36.16,36.16,0,0,0-1.93,3.66c-.31.63-.51,1.32-.78,2a19.24,19.24,0,0,0-.72,2.06,32.24,32.24,0,0,0-1,4.39,32.88,32.88,0,0,0-.16,9.47q.19,1.22.39,2.46c.15.82.41,1.62.62,2.44l.33,1.23.46,1.2c.33.8.57,1.64,1,2.41a34.4,34.4,0,0,0,6,8.91l1,1a8.42,8.42,0,0,0,1,1l2.12,1.85,2.31,1.67c.78.55,1.64,1,2.47,1.5a37.6,37.6,0,0,0,11.09,4l3,.44,3.07.16c2.06.05,4.15,0,6.26,0l-.25.25c0-2.7-.06-5.43-.09-8.22l.26.25-4.68.19a19,19,0,0,1-2.38,0,17.54,17.54,0,0,1-2.4-.21A28.85,28.85,0,0,1,217,242a28.08,28.08,0,0,1-13.67-14.22,23.9,23.9,0,0,1-1.9-8.24,23.16,23.16,0,0,1,.89-8.3,24.79,24.79,0,0,1,3.44-7.47,26.86,26.86,0,0,1,5.45-6,28.09,28.09,0,0,1,6.79-4.14l.9-.41.94-.32c.62-.2,1.23-.44,1.86-.62a31.67,31.67,0,0,1,3.8-.79,30.6,30.6,0,0,1,7.64-.19,30.25,30.25,0,0,1,3.71.64c.6.15,1.21.28,1.81.45l1.75.61a13.34,13.34,0,0,1,1.71.7c.55.26,1.12.49,1.66.77a29.31,29.31,0,0,1,3.09,1.89,28.81,28.81,0,0,1,5.3,4.71,26.38,26.38,0,0,1,5.93,12.07,24,24,0,0,1,.41,3.23c0,.54.05,1.08.08,1.61a4.55,4.55,0,0,0,.25,1.48,3.61,3.61,0,0,0,1.92,2.13,3.13,3.13,0,0,0,2.77-.12,3.7,3.7,0,0,0,1.73-2.17,8,8,0,0,0,.11-2.85,34,34,0,0,0-.7-5.6,35.06,35.06,0,0,0-3.8-9.74l-1.29-2.09c-.45-.67-1-1.28-1.43-1.9l-.7-.93c-.25-.29-.52-.56-.78-.84l-1.52-1.64a36.4,36.4,0,0,0-12.6-8,40.55,40.55,0,0,0-5.26-1.56c-1.57-.25-2.9-.48-4-.6l-2.47-.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268,310.11c0,3.61-2.66,6.54-5.93,6.54s-5.93-2.93-5.93-6.54,2.65-6.53,5.93-6.53S268,306.5,268,310.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.9,
    y: 188.62,
    width: 201.33,
    height: 8.43,
    style: {
      fill: "#09AD58"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.9,
    y: 178.29,
    width: 117.34,
    height: 8.43,
    style: {
      fill: "#09AD58"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.9,
    y: 369.8,
    width: 117.34,
    height: 8.43,
    style: {
      fill: "#09AD58"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.77,
    y: 160.15,
    width: 201.58,
    height: 12.29,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.6,
    y: 272.82,
    width: 201.58,
    height: 12.29,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.77,
    y: 212.28,
    width: 80.39,
    height: 12.29,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.67,
    y: 212.28,
    width: 100.51,
    height: 12.29,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.24,183.31c0,.14-25.86.25-57.77.25s-57.78-.11-57.78-.25,25.87-.26,57.78-.26S394.24,183.16,394.24,183.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.23,193c0,.14-44.72.26-99.87.26s-99.88-.12-99.88-.26,44.71-.26,99.88-.26S478.23,192.83,478.23,193Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.23,202.14c0,.14-44.72.26-99.87.26s-99.88-.12-99.88-.26,44.71-.26,99.88-.26S478.23,202,478.23,202.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.47,232.07c0,.14-18,.26-40.17.26s-40.16-.12-40.16-.26,18-.26,40.16-.26S357.47,231.93,357.47,232.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.47,241.51c0,.14-17.69.26-39.5.26s-39.5-.12-39.5-.26,17.68-.26,39.5-.26S357.47,241.37,357.47,241.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.14,251.11c0,.14-17.84.26-39.84.26s-39.83-.12-39.83-.26,17.83-.26,39.83-.26S357.14,251,357.14,251.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.14,260.42c0,.14-17.84.26-39.84.26s-39.83-.12-39.83-.26,17.83-.26,39.83-.26S357.14,260.28,357.14,260.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.63,234.28c0,.15-18.62.26-41.59.26s-41.61-.11-41.61-.26S411.06,234,434,234,475.63,234.14,475.63,234.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.05,237.29a12.07,12.07,0,0,1-.11-1.72c0-1.07-.09-2.54-.11-4.3l.22.23-5.73,0,.24-.26h0v1.6c0,.53,0,1,0,1.55,0,1,0,2,0,2.84l-.21-.22c1.67,0,3.07.07,4.08.11a16.51,16.51,0,0,1,1.65.11,7.59,7.59,0,0,1-1.51.11c-1,0-2.46.1-4.22.12h-.22v-.23c0-.88,0-1.84,0-2.84,0-.5,0-1,0-1.55v-1.6h0c-.22.24.3-.31.25-.26l5.73,0h.21v.22c0,1.86-.07,3.39-.11,4.44A10.44,10.44,0,0,1,386.05,237.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.63,245.85c0,.14-18.62.26-41.59.26s-41.61-.12-41.61-.26,18.63-.26,41.61-.26S475.63,245.7,475.63,245.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.05,248.86a12.49,12.49,0,0,1-.11-1.73c0-1.06-.09-2.54-.11-4.29l.22.22-5.73,0c-.06.05.46-.49.24-.26h0v1.6c0,.53,0,1,0,1.56,0,1,0,1.95,0,2.84l-.21-.23c1.67,0,3.07.07,4.08.12a11.42,11.42,0,0,1,1.65.11,10.32,10.32,0,0,1-1.51.11c-1,0-2.46.09-4.22.11h-.22v-.22c0-.89,0-1.84,0-2.84,0-.51,0-1,0-1.56v-1.6h0l.25-.26,5.73,0h.21v.23c0,1.85-.07,3.39-.11,4.43A10.88,10.88,0,0,1,386.05,248.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.63,257.41c0,.14-18.62.26-41.59.26s-41.61-.12-41.61-.26,18.63-.26,41.61-.26S475.63,257.27,475.63,257.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.05,260.42a12.31,12.31,0,0,1-.11-1.73c0-1.06-.09-2.53-.11-4.29l.22.22-5.73,0,.24-.26h0V256c0,.53,0,1.05,0,1.56,0,1,0,1.95,0,2.84l-.21-.22c1.67,0,3.07.07,4.08.11a13.5,13.5,0,0,1,1.65.11,8.75,8.75,0,0,1-1.51.11c-1,0-2.46.09-4.22.12h-.22v-.23c0-.89,0-1.84,0-2.84,0-.51,0-1,0-1.56v-1.61h0l.25-.26,5.73,0h.21v.22c0,1.86-.07,3.39-.11,4.44A10.81,10.81,0,0,1,386.05,260.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.63,353s0-.34,0-1,0-1.62,0-2.88c0-2.54,0-6.29,0-11.16,0-9.73-.05-23.95-.09-41.92l.15.16-198.47.1h0l.25-.26c0,19.59,0,38.69,0,56.94l-.24-.25,141.75.11,41.64.08,11.19,0h2.91l1,0-1,0h-2.88l-11.14,0-41.58.07-141.92.11h-.24V353c0-18.25,0-37.35,0-56.94v-.26h.26l198.47.1h.16v.16c0,18-.07,32.26-.09,42,0,4.85,0,8.59,0,11.12,0,1.25,0,2.2,0,2.85S475.63,353,475.63,353Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.63,310.41c0,.14-44.31.26-99,.26s-99-.12-99-.26,44.31-.26,99-.26S475.63,310.27,475.63,310.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.63,324.55c0,.14-44.31.26-99,.26s-99-.12-99-.26,44.31-.26,99-.26S475.63,324.41,475.63,324.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.63,338.84c0,.15-44.31.26-99,.26s-99-.11-99-.26,44.31-.26,99-.26S475.63,338.7,475.63,338.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.22,353.52c-.14,0-.25-12.88-.25-28.76s.11-28.77.25-28.77.25,12.88.25,28.77S300.36,353.52,300.22,353.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.34,351.79c-.14,0-.25-12.3-.25-27.47s.11-27.47.25-27.47.25,12.3.25,27.47S367.48,351.79,367.34,351.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.06,354.38c-.13,0-.24-12.68-.24-28.33s.11-28.33.24-28.33.25,12.68.25,28.33S438.2,354.38,438.06,354.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.69,365.78c0,.15-43.35.26-96.8.26s-96.8-.11-96.8-.26,43.33-.26,96.8-.26S471.69,365.64,471.69,365.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.69,374c0,.15-43.35.26-96.8.26s-96.8-.11-96.8-.26,43.33-.26,96.8-.26S471.69,373.87,471.69,374Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.54,382.24c0,.15-15.77.26-35.22.26s-35.23-.11-35.23-.26,15.77-.26,35.23-.26S348.54,382.1,348.54,382.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "224.58 353.27 235.88 353.27 235.85 343.54 224.58 343.54 224.58 353.27"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M230,277c-19.66,0-35.65,15.56-35.65,34.69s16.18,34.7,35.84,34.7h5.68l-.09-8.23-5.59.23c-15.65,0-28.58-12-28.58-26.7S214.35,285,230,285s28.39,12,28.39,26.69a3.65,3.65,0,1,0,7.26,0C265.66,292.6,249.66,277,230,277Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,277s.28,0,.84,0l2.48.1c1.09.09,2.42.31,4,.55a40.54,40.54,0,0,1,5.3,1.51,36.76,36.76,0,0,1,12.74,8l1.54,1.64c.26.28.53.55.78.85l.72.93c.47.63,1,1.24,1.44,1.92l1.32,2.1a35.64,35.64,0,0,1,3.87,9.83,33.69,33.69,0,0,1,.72,5.66,8.35,8.35,0,0,1-.11,3,4.12,4.12,0,0,1-1.91,2.41,3.58,3.58,0,0,1-3.13.15,4,4,0,0,1-2.15-2.37,5,5,0,0,1-.28-1.62l-.09-1.58a21.77,21.77,0,0,0-.4-3.18A26,26,0,0,0,251.84,295a28.19,28.19,0,0,0-5.22-4.63,30.17,30.17,0,0,0-3.05-1.85c-.53-.28-1.09-.5-1.64-.76a12.17,12.17,0,0,0-1.67-.68l-1.73-.6c-.58-.17-1.19-.29-1.78-.44a29.28,29.28,0,0,0-3.65-.63,31.17,31.17,0,0,0-11.26,1c-.61.17-1.21.41-1.83.61l-.91.32-.89.39a27.92,27.92,0,0,0-6.66,4.08,26.1,26.1,0,0,0-5.35,5.88,24.27,24.27,0,0,0-3.37,7.32,22.25,22.25,0,0,0-.87,8.13,23.33,23.33,0,0,0,1.86,8.07,27.56,27.56,0,0,0,13.42,14,28.3,28.3,0,0,0,9.17,2.71,15.42,15.42,0,0,0,2.35.2,18.4,18.4,0,0,0,2.35,0l4.67-.19h.27v.26q0,4.19.08,8.22v.26h-.25c-2.11,0-4.2,0-6.27,0l-3.11-.15-3.05-.46a37.64,37.64,0,0,1-11.23-4.09c-.84-.51-1.71-1-2.5-1.52l-2.33-1.7-2.15-1.88a8.51,8.51,0,0,1-1-1l-1-1a34.87,34.87,0,0,1-6-9c-.41-.78-.65-1.63-1-2.44l-.46-1.21-.34-1.25c-.2-.83-.47-1.65-.62-2.48l-.39-2.48a33.69,33.69,0,0,1,.19-9.59,31.72,31.72,0,0,1,1-4.43,18.27,18.27,0,0,1,.73-2.08c.27-.68.48-1.37.8-2a33.77,33.77,0,0,1,2-3.68l1.07-1.71c.38-.55.8-1.05,1.19-1.57a35.44,35.44,0,0,1,10.41-9.05c.44-.25.86-.52,1.29-.75l1.31-.6a20.17,20.17,0,0,1,2.48-1.07l2.34-.82c.75-.22,1.48-.38,2.16-.55a26.83,26.83,0,0,1,3.68-.68c.53-.06,1-.16,1.48-.19l1.23,0,1.66-.06c.38,0,.57,0,.57,0l-.57,0-1.66.11-1.22.07c-.46,0-.94.14-1.48.21a27,27,0,0,0-3.65.71c-.68.18-1.4.34-2.15.57l-2.31.83a21.82,21.82,0,0,0-2.47,1.08l-1.29.61c-.43.23-.84.5-1.28.75a35.3,35.3,0,0,0-10.28,9c-.39.52-.8,1-1.17,1.56l-1.06,1.7a36,36,0,0,0-1.93,3.65c-.31.63-.51,1.32-.78,2A20,20,0,0,0,196,302a34.56,34.56,0,0,0-1.14,13.87l.39,2.45c.15.82.41,1.62.62,2.45l.33,1.23.46,1.2c.33.79.57,1.63,1,2.41a34.4,34.4,0,0,0,6,8.91l1,1a8.34,8.34,0,0,0,1,1l2.12,1.85L210,340c.78.56,1.64,1,2.47,1.5a37,37,0,0,0,11.09,4l3,.45,3.07.15c2.06.06,4.15,0,6.26,0l-.25.25q0-4.05-.09-8.23l.26.25-4.68.19a19,19,0,0,1-2.38,0,17.52,17.52,0,0,1-2.4-.2,28.62,28.62,0,0,1-9.33-2.76,28,28,0,0,1-13.67-14.22,23.8,23.8,0,0,1-1.9-8.24,28,28,0,0,1,.07-4.2,28.34,28.34,0,0,1,.82-4.1,24.91,24.91,0,0,1,3.44-7.47,27.08,27.08,0,0,1,5.45-6,28.09,28.09,0,0,1,6.79-4.14l.9-.4.94-.32c.62-.21,1.23-.45,1.86-.62a31.72,31.72,0,0,1,3.8-.8,31.08,31.08,0,0,1,7.64-.19,34.61,34.61,0,0,1,3.71.64c.6.16,1.21.28,1.81.46l1.75.61a14.9,14.9,0,0,1,1.71.69c.55.26,1.12.5,1.66.78a29.31,29.31,0,0,1,3.09,1.89,28.1,28.1,0,0,1,5.3,4.71,26.28,26.28,0,0,1,5.93,12.07,23.77,23.77,0,0,1,.41,3.23c0,.54.05,1.07.08,1.61a4.6,4.6,0,0,0,.25,1.48,3.61,3.61,0,0,0,1.92,2.13,3.14,3.14,0,0,0,2.77-.13,3.67,3.67,0,0,0,1.73-2.17,7.93,7.93,0,0,0,.11-2.84,34,34,0,0,0-.7-5.6,35.13,35.13,0,0,0-3.8-9.75l-1.29-2.08c-.45-.67-1-1.28-1.43-1.91l-.7-.92c-.25-.3-.52-.57-.78-.85l-1.52-1.63a36.6,36.6,0,0,0-12.6-8,42,42,0,0,0-5.26-1.55c-1.57-.25-2.9-.49-4-.6l-2.47-.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "224.58 456.93 218.31 474.18 523.28 474.18 523.28 456.93 224.58 456.93"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M243.38,436.5s.45,0,1.33,0h3.92l15.1,0,55.84.28,187,1.13-.26.26V412.58c0-79.76.05-151.95.07-204.21,0-26.13.07-47.27.09-61.89,0-7.3,0-13,0-16.82,0-1.92,0-3.39,0-4.38s0-1.49,0-1.49,0,.5,0,1.49,0,2.46,0,4.38c0,3.85,0,9.52.05,16.82,0,14.62.05,35.76.08,61.89,0,52.26.05,124.45.08,204.21v25.88h-.26l-186.95-1.29-55.85-.45-15.09-.14-3.92-.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.05,432.25l1.33,0h19l55.72.13,186.67.61-.26.26c0-8.6,0-17.75,0-27,.12-80,.22-152.43.29-204.87.06-26.2.11-47.41.15-62.08,0-7.32.05-13,.06-16.88,0-1.92,0-3.39,0-4.39s0-1.49,0-1.49,0,.5,0,1.49,0,2.47,0,4.39c0,3.87,0,9.56,0,16.88,0,14.67,0,35.88,0,62.08,0,52.44-.08,124.86-.13,204.87,0,9.25,0,18.4,0,27v.26h-.26l-186.67-.78-55.72-.28-15.06-.11-3.91,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.26,440.57h5.25l15.08.05,55.76.28L509.85,442l-.26.26c0-7.53.06-15.56.09-23.66.33-79.07.63-150.63.85-202.44.14-25.9.25-46.86.32-61.35,0-7.24.09-12.86.11-16.68,0-1.9,0-3.35.05-4.34s0-1.48,0-1.48,0,.51,0,1.48,0,2.44,0,4.34c0,3.82,0,9.44,0,16.68,0,14.49-.09,35.45-.15,61.35-.18,51.81-.43,123.37-.7,202.44,0,8.1-.06,16.13-.09,23.66v.26h-.26l-186.5-1.28-55.76-.44-15.08-.14-3.92-.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "502.03 144.82 526.52 144.82 535.25 154.62 527.66 166.3 502.01 166.3 502.03 144.82",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Folders--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.88,307.43A3.36,3.36,0,0,1,17,303.62l4.16-28.92a2.78,2.78,0,0,1,3.23-2.26l2.72.39a2.88,2.88,0,0,0,2.8-1.18l.76-1.1a2.89,2.89,0,0,1,2.8-1.17l12.91,1.85a3,3,0,0,1,2.27,1.66l.49,1.1a2.9,2.9,0,0,0,2.26,1.66L67.89,278a2.78,2.78,0,0,1,2.46,3.07l-4.26,29.59a3.36,3.36,0,0,1-3.8,2.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.88,307.43A3.36,3.36,0,0,1,17,303.62l4.16-28.92a2.78,2.78,0,0,1,3.23-2.26l2.72.39a2.88,2.88,0,0,0,2.8-1.18l.76-1.1a2.89,2.89,0,0,1,2.8-1.17l12.91,1.85a3,3,0,0,1,2.27,1.66l.49,1.1a2.9,2.9,0,0,0,2.26,1.66L67.89,278a2.78,2.78,0,0,1,2.46,3.07l-4.26,29.59a3.36,3.36,0,0,1-3.8,2.85Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M49.8,275.42l-10.46-1.53L38.65,272a3.65,3.65,0,0,0-2.93-2.32l-10.24-1.47a3.23,3.23,0,0,0-3.74,2.62L21.57,272l-4.52,31.41a3.69,3.69,0,0,0,3.25,4.05l41.57,6a3.68,3.68,0,0,0,4.25-3l4.27-29.67a2.42,2.42,0,0,0-2-2.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.58,
    y: 286.5,
    width: 25,
    height: 10.52,
    transform: "translate(41.98 -3.44) rotate(8.18)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.72,292.38c0,.09-3.83-.38-8.52-1.06s-8.49-1.3-8.48-1.39,3.83.38,8.53,1.06S53.74,292.28,53.72,292.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4,294.59c0,.1-3.83-.38-8.52-1s-8.49-1.3-8.48-1.39,3.83.38,8.53,1.05S53.42,294.5,53.4,294.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,268.9A2.21,2.21,0,0,1,70.44,267L67.7,248a1.84,1.84,0,0,1,1.62-2l1.78-.25a1.92,1.92,0,0,0,1.56-1.27l.27-.83a1.87,1.87,0,0,1,1.55-1.26L83,241.15a1.94,1.94,0,0,1,1.73.63l.51.6A1.94,1.94,0,0,0,87,243l10.82-1.56a1.83,1.83,0,0,1,2.12,1.48l2.81,19.45a2.22,2.22,0,0,1-1.88,2.5Z",
    style: {
      fill: "#09AD58"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73,268.9A2.21,2.21,0,0,1,70.44,267L67.7,248a1.84,1.84,0,0,1,1.62-2l1.78-.25a1.92,1.92,0,0,0,1.56-1.27l.27-.83a1.87,1.87,0,0,1,1.55-1.26L83,241.15a1.94,1.94,0,0,1,1.73.63l.51.6A1.94,1.94,0,0,0,87,243l10.82-1.56a1.83,1.83,0,0,1,2.12,1.48l2.81,19.45a2.22,2.22,0,0,1-1.88,2.5Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M85.88,243.16l-6.88,1-.78-1.06a2.39,2.39,0,0,0-2.28-.91l-6.73,1a2.12,2.12,0,0,0-1.88,2.34l.12.78,3,20.65a2.4,2.4,0,0,0,2.79,1.95l27.33-3.94a2.42,2.42,0,0,0,2.13-2.66l-2.82-19.51a1.58,1.58,0,0,0-1.8-1.34Z",
    style: {
      fill: "#09AD58"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.71,
    y: 250.89,
    width: 16.43,
    height: 6.91,
    transform: "translate(-35.44 14.88) rotate(-8.21)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5,253.13c0,.06-2.49.47-5.57.92s-5.6.75-5.61.69,2.49-.47,5.58-.91S91.49,253.07,91.5,253.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.71,254.59c0,.06-2.49.47-5.57.91s-5.6.76-5.61.7,2.49-.47,5.58-.91S91.7,254.53,91.71,254.59Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-2--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M617.65,164l6.51.84a21,21,0,1,0-2.6-7h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.65,164s.1-.14.27-.41.43-.67.76-1.19c.67-1,1.66-2.58,2.93-4.58h-.11a.07.07,0,0,0,.09,0,.07.07,0,0,0,0-.07,20.85,20.85,0,0,1,.81-10.27,21.63,21.63,0,0,1,1.28-3,23.72,23.72,0,0,1,1.87-2.9,20.78,20.78,0,0,1,13.2-8,21.1,21.1,0,0,1,8.84.45,20.81,20.81,0,0,1,15.17,22.4,21.26,21.26,0,0,1-3.24,9,20.52,20.52,0,0,1-6.44,6.29,20.88,20.88,0,0,1-15.41,2.66l-.86-.2A4.87,4.87,0,0,1,636,174l-1.62-.56a30.31,30.31,0,0,1-2.91-1.44,20.8,20.8,0,0,1-7.25-7.24.05.05,0,0,0-.05,0l-4.83-.58-1.25-.15-.44-.05.41.06,1.23.18,4.86.66,0,0a20.85,20.85,0,0,0,7.26,7.35,28.57,28.57,0,0,0,2.93,1.46l1.64.58a5.93,5.93,0,0,0,.85.24l.88.21A21,21,0,0,0,653.26,172a20.74,20.74,0,0,0,6.54-6.36,21.36,21.36,0,0,0,3.28-9.13,20.79,20.79,0,0,0-1.31-10.06,9.35,9.35,0,0,0-.5-1.17l-.55-1.15-.65-1.08a8.27,8.27,0,0,0-.69-1.05c-.25-.34-.5-.67-.74-1a12.26,12.26,0,0,0-.82-.94c-.28-.3-.54-.63-.84-.91l-.91-.83a20.79,20.79,0,0,0-8.37-4.5A21.14,21.14,0,0,0,631,136.36a20.82,20.82,0,0,0-5.56,5.13,23.47,23.47,0,0,0-1.88,2.94,20.14,20.14,0,0,0-1.27,3,20.93,20.93,0,0,0-.76,10.37l.12,0h0a.07.07,0,0,0-.09,0l0,0-2.88,4.67-.73,1.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.43,150.34h2.85a2.43,2.43,0,0,1,2.49-2.44,2.31,2.31,0,0,1,2.24,1.48,2.56,2.56,0,0,1-.2,2.31c-.49.8-1.55,1.52-3.47,1.18v6.44h2.82v-3.77a5.51,5.51,0,0,0,4-5.39c0-4.17-3.74-5.14-5.35-5.14C640.55,145,636.37,145.31,636.43,150.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640.33,
    y: 160.64,
    width: 2.87,
    height: 2.68,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-1--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.79,218l-7.33-.08a23.58,23.58,0,1,1,4.75-7h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.79,218l-.19-.47c-.12-.33-.29-.78-.52-1.36-.45-1.21-1.11-2.95-2-5.2l.19,0h0a.11.11,0,0,1-.19-.12,23.47,23.47,0,0,0,1.89-11.3,23.1,23.1,0,0,0-1.81-7.25,23.27,23.27,0,0,0-40.63-4.13c-.27.4-.54.79-.8,1.2l-.68,1.25-.33.63-.28.65-.56,1.3a23.94,23.94,0,0,0-1.29,5.41,23.35,23.35,0,0,0,29.94,25.07,23.28,23.28,0,0,0,9.82-5.88l.08,0,5.42.13,1.42,0,.49,0H98.46l.08,0a23.46,23.46,0,0,1-9.88,6.05,23.8,23.8,0,0,1-29.34-14.63,24.15,24.15,0,0,1,.11-16.36l.56-1.33.29-.67.34-.64.7-1.28c.26-.41.54-.81.81-1.22A23.73,23.73,0,0,1,98.87,185a23.38,23.38,0,0,1,4.68,7.19,22.92,22.92,0,0,1,1.79,7.37,23.56,23.56,0,0,1-2,11.42l-.19-.11h0a.1.1,0,0,1,.15,0,.1.1,0,0,1,0,0l1.86,5.32.46,1.35A3.75,3.75,0,0,1,105.79,218Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5,206.54a7.65,7.65,0,1,1,4.3-1.33A7.63,7.63,0,0,1,80.5,206.54Zm0-13.29a5.59,5.59,0,0,0-3.18,1,5.67,5.67,0,1,0,3.18-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.64,211.83a1,1,0,0,1-.83-.44L83.41,205a1,1,0,0,1,.26-1.39,1,1,0,0,1,1.4.26l4.39,6.44a1,1,0,0,1-.26,1.39A1,1,0,0,1,88.64,211.83Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M581.24,437.4,575.58,457s18,12.33,17.32,16.05l-38.38-9.6,7.56-30.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.13,452.36a1.61,1.61,0,0,0-1.53,1.52,1.54,1.54,0,0,0,1.49,1.53,1.7,1.7,0,0,0,1.61-1.61,1.61,1.61,0,0,0-1.73-1.42",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M554.52,463.45l.88-3.09,36.48,10.36s1.52,1.17,1,2.33Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M576.25,457c0,.18-1,0-2.08.41s-1.76,1-1.92.91.4-1.13,1.7-1.55S576.33,456.8,576.25,457Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.86,459.63c0,.19-.89.31-1.73.94s-1.23,1.43-1.41,1.37,0-1.14,1-1.91S579.9,459.45,579.86,459.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.94,465c-.18,0-.2-1,.53-1.91s1.72-1.1,1.76-.92-.64.59-1.23,1.34S581.13,465.05,580.94,465Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577,452.35c-.12.15-.91-.32-2-.52s-2-.06-2-.25.9-.65,2.17-.41S577.17,452.22,577,452.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.78,442l-.89,20.37s20.41,7.75,20.61,11.53l-39.56-.31.08-31.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.67,460.58a1.61,1.61,0,0,0-1.13,1.84,1.55,1.55,0,0,0,1.81,1.13,1.69,1.69,0,0,0,1.18-1.95,1.6,1.6,0,0,0-2-1",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M547.94,473.61l.13-3.2L586,471.9s1.75.78,1.54,2Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M567.53,462.19c0,.2-1,.28-1.93.89s-1.47,1.42-1.64,1.35.12-1.2,1.29-1.92S567.58,462,567.53,462.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.67,463.94c0,.19-.8.51-1.46,1.32s-.86,1.68-1.05,1.67-.31-1.1.53-2.1S571.67,463.76,571.67,463.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574,468.93c-.18,0-.44-.93.06-2s1.42-1.47,1.5-1.31-.49.72-.89,1.59S574.18,468.91,574,468.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.22,457.53c-.08.17-1-.1-2.06,0s-1.95.4-2,.23.73-.85,2-.91S567.32,457.38,567.22,457.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.73,457.3a33.13,33.13,0,0,1,0,4.9l-.16-.24c2.31.88,5.39,2.06,8.65,3.6a46.74,46.74,0,0,1,8.77,5.05,9.56,9.56,0,0,1,2.17,2.21c.41.64.36,1.12.29,1.1a2.73,2.73,0,0,0-.5-.95,11.17,11.17,0,0,0-2.24-2,57.72,57.72,0,0,0-8.77-4.83c-3.24-1.53-6.28-2.76-8.55-3.73l-.17-.08v-.17A31.94,31.94,0,0,1,567.73,457.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.8,305.74v14.63l3.93,57s-2.45,27.66-4,43.27c-1.31,13.55.83,37.16.83,37.16h22.87l8.18-78.73L582.74,330l8.84-22.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "607.23 308.35 601.65 387.81 578.51 447.36 577.45 450.94 563.78 447.64 573.94 306.74 607.23 308.35",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.49,319.37a1.32,1.32,0,0,1,0,.36c0,.26,0,.61,0,1.06,0,.95-.08,2.31-.14,4.06-.11,3.52-.39,8.61-.79,14.9-.84,12.58-2.4,29.93-4.84,49s-5,36.35-7,48.83c-1,6.22-1.78,11.26-2.34,14.77-.28,1.72-.5,3.07-.66,4q-.11.66-.18,1.05a1.5,1.5,0,0,1-.08.35,1.64,1.64,0,0,1,0-.36c0-.26.07-.61.13-1.05l.56-4c.52-3.52,1.26-8.57,2.17-14.79,1.85-12.49,4.43-29.74,6.83-48.85s4-36.43,5-49c.45-6.29.79-11.37,1-14.89.1-1.74.18-3.1.24-4,0-.45,0-.8.07-1.06A2.19,2.19,0,0,1,585.49,319.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.52,162.5l0,38.33c0,6.52,7.81,18.2,18.12,17.74l.84,0c8.91-1.08,3.84-11.68,3.84-17.76,0-2.88,0-5.29,0-5.59,0,0,9.76-.9,10.47-10.56.35-4.67.28-14.34.11-23.08A18,18,0,0,0,586,144l-.93-.06C574.93,143.86,569.27,152.42,569.52,162.5Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.31,195.24A23.32,23.32,0,0,1,580,190.75s2.64,7.25,12.33,7Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.44,165.74c-.19.2-1.31-.69-2.93-.71s-2.82.78-3,.58.11-.46.64-.83a4,4,0,0,1,2.39-.71,3.86,3.86,0,0,1,2.33.82C586.37,165.29,586.53,165.65,586.44,165.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.66,170.24a1.31,1.31,0,0,1-1.34,1.24,1.24,1.24,0,0,1-1.27-1.26,1.32,1.32,0,0,1,1.34-1.24A1.25,1.25,0,0,1,586.66,170.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.62,176.94a9.5,9.5,0,0,1,2.44-.29c.38,0,.74-.07.82-.32a1.87,1.87,0,0,0-.18-1.14l-1-3c-1.3-4.21-2.22-7.66-2-7.71s1.36,3.32,2.67,7.53l.9,3a2.23,2.23,0,0,1,.1,1.5,1,1,0,0,1-.66.51,2.53,2.53,0,0,1-.65.05A10.07,10.07,0,0,1,590.62,176.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.68,160.49c-.15.36-1.45.1-3,.2s-2.81.45-3,.11c-.08-.16.16-.49.68-.82a4.73,4.73,0,0,1,2.26-.66,4.8,4.8,0,0,1,2.31.42C585.48,160,585.75,160.32,585.68,160.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.07,161.82c-.17.29-1.43,0-3,0s-2.8.18-3-.12.17-.41.7-.65a5.42,5.42,0,0,1,2.26-.4,5.47,5.47,0,0,1,2.25.53C600.89,161.4,601.14,161.68,601.07,161.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.87,169.71c-.16-.08-6.52-2.37-6.72,4.25s6.5,5.44,6.51,5.26S569.87,169.71,569.87,169.71Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.71,176.65s-.11.08-.31.16a1.15,1.15,0,0,1-.86,0,2.87,2.87,0,0,1-1.25-2.6,3.91,3.91,0,0,1,.37-1.64,1.33,1.33,0,0,1,.9-.86.59.59,0,0,1,.67.34c.08.19,0,.32.07.33s.15-.11.1-.38a.75.75,0,0,0-.25-.43.88.88,0,0,0-.63-.18,1.62,1.62,0,0,0-1.24,1,4,4,0,0,0-.45,1.83,3,3,0,0,0,1.6,2.91,1.26,1.26,0,0,0,1.06-.14C567.7,176.81,567.74,176.66,567.71,176.65Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561,159.1c1.35-2.35,1.64-5.14,2.36-7.75s2.14-5.33,4.69-6.27l0,0c2.29-.94,5.11-1,7,.58.43-3.44,3.41-6.2,6.76-7.12a22.4,22.4,0,0,1,12,.8c2.5,1,4.93,3,7.89,6a31.45,31.45,0,0,1,3.42,4l3,9-2.45,4.76c-.15.32-.3.64-.48,1v0l-2.14,10c-.18-2.72-.09-12.17-.26-14.88a15.15,15.15,0,0,1-10.86-4.86c-1.5-1.63-2.69-3.68-4.68-4.63-2.58-1.24-5.62-.28-8.3.68l.11-.1a12,12,0,0,0-3.7,2.74,37.67,37.67,0,0,1-1.45,16c-.24.77-.92,2.36-1.67,2.67-1.48.59-1.89-.92-2.8-1.71a3.92,3.92,0,0,0-2.71-.64,60.68,60.68,0,0,1-1.89-6.84,6.09,6.09,0,0,1-2.78.21c.28-.68.55-1.37.83-2a3.18,3.18,0,0,1-1.18.55,1.07,1.07,0,0,1-1.13-.48C560.33,160.18,560.66,159.59,561,159.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.11,146.75a9.22,9.22,0,0,0-1,.9,6.91,6.91,0,0,0-1.44,3.22,12.5,12.5,0,0,0-.22,2.46c0,.88.09,1.83.17,2.84a25,25,0,0,1,.11,3.16,12.07,12.07,0,0,1-.2,1.67,3.44,3.44,0,0,1-.66,1.63,1.44,1.44,0,0,1-1.36.47,2.2,2.2,0,0,1-1.23-.67,5,5,0,0,1-1-2.45l.2,0a7.91,7.91,0,0,1-1.15,2,2.89,2.89,0,0,1-1.86,1,1.78,1.78,0,0,1-1-.16,1.5,1.5,0,0,1-.68-.66,1.64,1.64,0,0,1-.22-.85,1.15,1.15,0,0,1,.3-.75l.11.09a6.41,6.41,0,0,1-2.06,1.58,5,5,0,0,1-.64.25.7.7,0,0,1-.23.06,1.35,1.35,0,0,1,.22-.09c.14-.06.35-.15.62-.29a6.47,6.47,0,0,0,2-1.6l.1.09a1.22,1.22,0,0,0,0,1.43,1.47,1.47,0,0,0,.62.59,1.68,1.68,0,0,0,.9.13,2.67,2.67,0,0,0,1.73-1,8,8,0,0,0,1.11-2l.13-.31.07.33a4.86,4.86,0,0,0,.91,2.34,2,2,0,0,0,1.11.6,1.22,1.22,0,0,0,1.15-.4,3.24,3.24,0,0,0,.61-1.52,11.65,11.65,0,0,0,.2-1.64,26.87,26.87,0,0,0-.1-3.14c-.07-1-.15-2-.15-2.85a12.72,12.72,0,0,1,.25-2.49,6.93,6.93,0,0,1,1.54-3.25A4,4,0,0,1,578.11,146.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.07,155.8l-.07.06-.24.18a3.24,3.24,0,0,1-.41.27,4.35,4.35,0,0,1-.58.31,8.55,8.55,0,0,1-4.12.8,10.93,10.93,0,0,1-5.85-2.09,18.72,18.72,0,0,1-5.07-5.71c-.72-1.16-1.3-2.35-2-3.45a12.76,12.76,0,0,0-2.19-2.91,6.61,6.61,0,0,0-2.8-1.66,4.64,4.64,0,0,0-2.81.13,5.44,5.44,0,0,0-2,1.23,5.37,5.37,0,0,0-1.08,1.43,7.72,7.72,0,0,0-.48,1.45.67.67,0,0,1,0-.1l0-.3a4.82,4.82,0,0,1,.36-1.09,5.35,5.35,0,0,1,1.06-1.48,5.54,5.54,0,0,1,2-1.29,4.78,4.78,0,0,1,1.38-.3,5,5,0,0,1,1.53.14,6.86,6.86,0,0,1,2.9,1.69,12.57,12.57,0,0,1,2.23,2.95c.66,1.11,1.24,2.3,1.95,3.45a18.92,18.92,0,0,0,5,5.65,10.84,10.84,0,0,0,5.74,2.1,8.67,8.67,0,0,0,4.07-.72A13.25,13.25,0,0,0,608.07,155.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.18,166.18c-.19.2-1.31-.69-2.93-.71s-2.81.78-3,.57.12-.45.64-.82a4,4,0,0,1,4.72.1C601.11,165.72,601.27,166.09,601.18,166.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.72,170.24a1.31,1.31,0,0,1-1.34,1.24,1.24,1.24,0,0,1-1.27-1.26,1.32,1.32,0,0,1,1.34-1.24A1.25,1.25,0,0,1,599.72,170.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.28,148.29a4.15,4.15,0,0,0,3.44,1.93,9.81,9.81,0,0,0,1.44-.42c.47.29.36,1.9,0,2.35a9.71,9.71,0,0,1-1,1c1.58.85,3,.43,4.72-.18a8.3,8.3,0,0,1-4.93,6.64,2.9,2.9,0,0,1-2.67.05,3.37,3.37,0,0,1-1.17-2.08,36.85,36.85,0,0,1-1.18-8.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.63,181.09c0,.08-.29.29-.89.38a3.64,3.64,0,0,1-2.3-.47,3.55,3.55,0,0,1-1.52-1.78c-.21-.57-.18-.95-.1-1s.56,1.36,2,2.18S590.6,180.9,590.63,181.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.31,234.55l2.21,20.84,30.84,8s.91,10.86,0,11.12-38.4.6-41.76-4.59-.43.95-.83,0S600.63,238,600.63,238Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.05,273.41s8.52,1,10.51,1.06,7.63-1.37,7.63-1.37,9.2,1.76,9.67,1.27,1.1-1,.53-1.44-7.59-2.69-7.59-2.69l4.81-.07s6.9,1.91,7.43,1.72,1.25-1,.85-1.72l-.4-.69a1.49,1.49,0,0,0-.62-1.88l-.65-.27.18-.58a2.31,2.31,0,0,0-1-2.3c-1.35-.95-4.17-3.05-4.17-3.05L658.34,260l-17,2.53",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.37,270.28a12.1,12.1,0,0,0,1,.89,6.15,6.15,0,0,0,3.47,1,13.37,13.37,0,0,0,5.26-1.38c1.91-.8,4-1.91,6.55-2a16.37,16.37,0,0,0,1.75,0,.87.87,0,0,0,.81-.89c-.06-.36-.65-.48-1.18-.6l-1.56-.39-5.4-1.35-3.63-1a7.72,7.72,0,0,1-1.32-.42,6.15,6.15,0,0,1,1.37.22l3.66.79,5.43,1.25,1.57.36a6.59,6.59,0,0,1,.83.23,1.1,1.1,0,0,1,.73.75,1.37,1.37,0,0,1-1.21,1.51,16.23,16.23,0,0,1-1.82,0c-2.37.12-4.46,1.17-6.4,2a13.23,13.23,0,0,1-5.45,1.31,6.06,6.06,0,0,1-3.58-1.2,4.09,4.09,0,0,1-.73-.73A1.12,1.12,0,0,1,641.37,270.28Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.36,264.65c0-.16,3.36.24,7.43-.25.51-.06,1-.14,1.48-.21l.12,0,.08.08a18,18,0,0,0,5.18,2.76,4.16,4.16,0,0,1-1.7-.31,11.73,11.73,0,0,1-3.8-2.06l.2.06c-.48.08-1,.15-1.49.21a27.23,27.23,0,0,1-5.33.11A7.46,7.46,0,0,1,657.36,264.65Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.49,267.52c.06-.14,1.79.6,4,1.08s4.11.54,4.12.69a12.41,12.41,0,0,1-8.15-1.77Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.83,309.41s-2.36-63.81-3.54-74.88-4.06-31-4.06-31l-10-3.7,0,.09c.11,1.24,0,6.21-3.79,6.94-10.26,2-19.37-9.43-19.37-9.43l-20.14,10,2.26,57.91-6,40.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.17,262.79l-40-4.33,4.23-26.55L546.92,226h-5.17s-2.9,29.13-3.57,34.56c-.71,5.75,0,15.28,12.33,15.83,6,.26,45.74-2.67,45.74-2.67Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.47,208.71c8.58,5,5.5,35.09,5.5,35.09L536.89,243l3.38-23.86a17.64,17.64,0,0,1,5.5-9.4,11.27,11.27,0,0,1,5.59-2.95A7,7,0,0,1,557.47,208.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.92,212.12c-2.73-6.34-9.8-8.61-9.8-8.61l2.77,38,13.86-1S615.38,220.19,611.92,212.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.84,216.12c.14,0,.65,7.83,1.14,17.5s.77,17.51.62,17.52-.65-7.83-1.14-17.5S605.7,216.13,605.84,216.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.85,273.41s8.52,1,10.51,1.06S611,273.1,611,273.1s9.2,1.76,9.67,1.27,1.1-1,.53-1.44-7.58-2.69-7.58-2.69l4.8-.07s6.9,1.91,7.43,1.72,1.25-1,.85-1.72l-.4-.69a1.49,1.49,0,0,0-.62-1.88l-.65-.27.18-.58a2.31,2.31,0,0,0-1-2.3c-1.35-.95-4.17-3.05-4.17-3.05L611.15,260l-17,2.53",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.14,262.56a.94.94,0,0,1,.3-.07l.88-.17,3.4-.56,12.4-1.93h.06l8.86,1.34h.05l0,0,3.08,2.25a14.35,14.35,0,0,1,1.61,1.25,2.54,2.54,0,0,1,.62,2.1h0c-.05.18-.12.38-.18.58l-.14-.31.64.26h0a1.55,1.55,0,0,1,.81.94,2.12,2.12,0,0,1-.06,1.27l0-.23c.16.3.32.51.49.89a1.32,1.32,0,0,1-.19,1.15,1.9,1.9,0,0,1-.85.73.93.93,0,0,1-.36,0l-.26,0-.5-.09c-1.32-.26-2.62-.59-3.94-.93l-2.56-.69h.08l-4.81.06.08-.5c1.73.57,3.43,1.14,5.08,1.73a24.7,24.7,0,0,1,2.45.95.73.73,0,0,1,.32.27.62.62,0,0,1,.11.47,1.35,1.35,0,0,1-.37.66c-.15.17-.3.32-.44.46a.67.67,0,0,1-.44.16h-.34a42.77,42.77,0,0,1-4.77-.61c-1.51-.25-3-.52-4.34-.79H611a44.3,44.3,0,0,1-7.49,1.33c-2.27-.1-4.18-.38-5.77-.55l-3.65-.46-1-.14-.32-.07s.11,0,.33,0l1,.08,3.67.36c1.58.13,3.53.37,5.74.45a46.34,46.34,0,0,0,7.39-1.4H611c1.37.26,2.83.51,4.34.76a46.1,46.1,0,0,0,4.7.57h.28c.09,0,.19,0,.15,0l.42-.44a1.07,1.07,0,0,0,.25-.42c0-.09,0-.16-.19-.25-.71-.33-1.57-.61-2.37-.9-1.65-.58-3.35-1.14-5.08-1.71l-1.47-.48,1.54,0,4.81-.07h.07l2.55.68c1.32.34,2.62.68,3.9.93l.48.09a1.72,1.72,0,0,0,.36,0,1.4,1.4,0,0,0,.61-.53.83.83,0,0,0,.13-.7c-.09-.21-.3-.54-.44-.8l-.06-.1,0-.12a1.57,1.57,0,0,0,.05-.93,1.06,1.06,0,0,0-.55-.64h0l-.64-.26-.22-.09.07-.22c.06-.2.13-.4.18-.58v0a2,2,0,0,0-.5-1.66,15.65,15.65,0,0,0-1.52-1.18l-3.08-2.27.1,0-8.85-1.4h.07L598.76,262l-3.42.45-.89.11A1,1,0,0,1,594.14,262.56Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.52,265.82a5.65,5.65,0,0,0,2.12.49,22.49,22.49,0,0,1,5.1.77,27.55,27.55,0,0,1,2.55,1.28,19.28,19.28,0,0,0,2.17.94,7.68,7.68,0,0,0,2.1.57,21,21,0,0,0-2-.84c-.61-.27-1.33-.6-2.1-1a22.86,22.86,0,0,0-2.58-1.32,10.45,10.45,0,0,0-2.88-.56c-.89-.06-1.68-.07-2.34-.11C613.34,266,612.54,265.76,612.52,265.82Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.45,263.37a4.67,4.67,0,0,0,1.91.37,10.1,10.1,0,0,1,4.44.86c1.62.8,3.08,1.57,4.16,2.08a9.73,9.73,0,0,0,1.77.76,8.83,8.83,0,0,0-1.64-1c-1-.57-2.47-1.38-4.11-2.19a7.13,7.13,0,0,0-2.51-.72c-.8-.08-1.51-.05-2.1-.06C614.18,263.45,613.47,263.31,613.45,263.37Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.59,243a1.57,1.57,0,0,1,.47,0h1.34l4.92.07c4.15.09,9.89.24,16.23.44l1.43,0-.27.27c-.15-4.84-.29-9.27-.41-12.83v0c-.3-2.66-.4-4.82-.51-6.33,0-.69-.09-1.26-.12-1.73a3.51,3.51,0,0,1,0-.61,1.88,1.88,0,0,1,.14.6c.06.39.14,1,.22,1.72.19,1.5.35,3.68.69,6.29v0h0c.15,3.55.32,8,.52,12.82v.28H563l-1.43,0c-6.34-.2-12.07-.41-16.22-.59l-4.92-.23-1.33-.1A1.47,1.47,0,0,1,538.59,243Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 651.12,
    y: 375.93,
    width: 7.94,
    height: 95.65,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 641.17,
    y: 359.2,
    width: 3.45,
    height: 6.48,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 644.36,
    y: 361.15,
    width: 3.96,
    height: 2.68,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 647.51,
    y: 282.62,
    width: 15.14,
    height: 93.31,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.66,375.93s0-.17,0-.49,0-.79,0-1.39c0-1.24,0-3,0-5.34,0-4.65,0-11.37-.07-19.73,0-16.72-.07-40-.12-66.36l.26.26H647.52l.26-.26c-.06,39.94-.11,74.83-.13,93.31l-.13-.13,11.19.07,2.93,0h.76l.26,0h-1l-2.9,0-11.27.08h-.14v-.13c0-18.48-.07-53.37-.13-93.31v-.26h15.67v.26c0,26.42-.09,49.77-.12,66.54,0,8.34,0,15-.07,19.67,0,2.29,0,4.06,0,5.29,0,.58,0,1,0,1.36S662.66,375.93,662.66,375.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 625.26,
    y: 469.77,
    width: 59.38,
    height: 4.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 526.3,
    y: 273.56,
    width: 202.57,
    height: 9.06,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.87,282.62s0-.19,0-.56,0-.92,0-1.66c0-1.5,0-3.75,0-6.84l.07.07-202.56.19h0l.26-.26v9.06l-.26-.26,143.49.11,43.23.07,11.74,0,3.06,0,1,0-1,0h-3l-11.68,0-43.17.08-143.68.11H526V273.3h.27l202.56.19H729v.07c0,3.11,0,5.38-.05,6.88,0,.73,0,1.28,0,1.65S728.87,282.62,728.87,282.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.45,221H634.38c-1.86,0-3.64,1-3.92,3L623,269.71h-29.5a1.87,1.87,0,0,0,0,3.73h94.24l6.44-47.8A4,4,0,0,0,690.45,221Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.45,221a4.57,4.57,0,0,1,1,.15,3.77,3.77,0,0,1,2.18,1.75,4.23,4.23,0,0,1,.58,2,6.37,6.37,0,0,1-.1,1.21c-.05.42-.12.86-.18,1.31-.25,1.83-.53,3.93-.86,6.29-1.28,9.46-3.13,23.08-5.4,39.78l.1-.08-91.11,0H593.5a1.55,1.55,0,0,1-.56-.11,1.64,1.64,0,0,1-.84-.76,1.86,1.86,0,0,1,.3-2.15,1.54,1.54,0,0,1,1-.47h29.67l0-.1c2.5-15.37,4.83-29.71,6.93-42.57.13-.8.26-1.6.38-2.39.07-.4.13-.8.21-1.18a3,3,0,0,1,.46-1,3.43,3.43,0,0,1,1.84-1.29,4.79,4.79,0,0,1,1.12-.2c.38,0,.77,0,1.15,0h8.88l15.79,0,22.48,0,6,0h0l-6,0-22.48,0H635.2c-.38,0-.76,0-1.16,0a5.77,5.77,0,0,0-1.16.21,3.68,3.68,0,0,0-2,1.36,3.53,3.53,0,0,0-.5,1.12c-.08.4-.13.79-.2,1.19l-.39,2.39c-2.11,12.86-4.45,27.2-7,42.56l.11-.1H593.4a1.73,1.73,0,0,0-1.17.54,2.09,2.09,0,0,0-.34,2.43,1.88,1.88,0,0,0,1,.88,1.78,1.78,0,0,0,.65.12h3.12l91.11,0h.08v-.09c2.23-16.7,4-30.33,5.32-39.78q.47-3.55.83-6.3l.18-1.31a7.39,7.39,0,0,0,.09-1.22,4.29,4.29,0,0,0-.6-2,3.74,3.74,0,0,0-2.22-1.74,2.71,2.71,0,0,0-.72-.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.43,248.42a3.89,3.89,0,1,0,3.89-3.89A3.89,3.89,0,0,0,656.43,248.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.85,273c.09,0,2.07-11.52,4.42-25.76s4.19-25.8,4.1-25.81-2.06,11.52-4.42,25.76S625.77,273,625.85,273Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.35,224.24l-13,9.59q2,5.79,4,11.59A28.06,28.06,0,0,0,160.35,224.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.18,201.18a17,17,0,0,1,11.42-1.38,36.11,36.11,0,0,1,10.81,4.47,17.56,17.56,0,0,1,5.16,4c2.5,3.13,5,8.29,5.2,12.29.2,3.24-1,11.34-2.41,14.28-1.25,2.69-7.13,4.75-10,5.41l-26.6-30.94A13.44,13.44,0,0,1,130.18,201.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.59,205.35l6.38-1.14c-3.49,8.3-4.43,27.29-6.43,36.07-2.35-3.41-7.81-13.8-7.51-17.93S118,204.65,125.59,205.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.83,219.17a10.88,10.88,0,0,0-8.2-10L133,205.39c-6.35-.68-10.59,7.13-11,13.5-.47,7.08-.75,14.54.08,19.83,1.66,10.62,9.8,12,9.8,12v8.16l4.92,20.34,16.38-17.67,2.74-42.24C155.87,219.12,155.85,219.41,155.83,219.17Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.14,226.91a1.36,1.36,0,0,0,1.31,1.38,1.3,1.3,0,0,0,1.4-1.23,1.36,1.36,0,0,0-1.3-1.37A1.29,1.29,0,0,0,125.14,226.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.54,223.05c.17.18,1.2-.58,2.67-.58s2.54.74,2.7.57-.1-.4-.56-.75a3.79,3.79,0,0,0-2.16-.67,3.66,3.66,0,0,0-2.13.68C123.61,222.65,123.46,223,123.54,223.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.91,226.91a1.37,1.37,0,0,0,1.31,1.38,1.31,1.31,0,0,0,1.41-1.23,1.36,1.36,0,0,0-1.31-1.37A1.3,1.3,0,0,0,137.91,226.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.46,223.05c.17.18,1.2-.58,2.67-.58s2.54.75,2.7.57-.1-.4-.56-.75a3.79,3.79,0,0,0-2.16-.67,3.66,3.66,0,0,0-2.13.68C137.53,222.65,137.38,223,137.46,223.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.88,234.56a10.15,10.15,0,0,0-2.38-.43c-.38,0-.73-.12-.79-.37a1.88,1.88,0,0,1,.25-1.11q.53-1.36,1.11-2.85c1.55-4.06,2.67-7.39,2.51-7.45s-1.55,3.18-3.1,7.23c-.37,1-.73,1.95-1.07,2.86a2.19,2.19,0,0,0-.19,1.47.92.92,0,0,0,.61.55,2.22,2.22,0,0,0,.63.09A9.45,9.45,0,0,0,132.88,234.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.91,246.93s-3.45,7.3-14.08,6.28v-2.5A26.72,26.72,0,0,0,145.91,246.93Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.92,217.75c.14.4,1.61.22,3.33.43s3.11.68,3.33.32c.11-.17-.13-.54-.69-.93a5.85,5.85,0,0,0-5.08-.57C138.18,217.25,137.86,217.56,137.92,217.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,218.57c.26.33,1.27,0,2.48,0s2.24.23,2.48-.12c.1-.17-.06-.5-.51-.82a3.48,3.48,0,0,0-2-.55,3.44,3.44,0,0,0-2,.67C124.05,218.06,123.91,218.4,124,218.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.83,209.19a4.68,4.68,0,0,1,4.13-2.65,9.19,9.19,0,0,1,4.9,1.43c6.32,3.66,9.57,12.49,15.82,16.27,1.54.93,3.54.08,4.85,1.31s2.15,3.2,1.43,4.85a15,15,0,0,0,2.17-3.67,5,5,0,0,0-.18-4.14c-.54-.94-1.49-1.65-1.75-2.7a13.54,13.54,0,0,1,.09-2.84,6.24,6.24,0,0,0-1-2.71,27.54,27.54,0,0,0-10.16-10.68,18,18,0,0,0-9.32-2.41,13.73,13.73,0,0,0-8.87,3.52c-1.39,1.3-2.86,2.65-2.14,4.42",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.38,226.87c.11-.31,5.65-2.31,5.72,3.58.07,5.72-5.7,4.6-5.71,4.43S154.38,226.87,154.38,226.87Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.13,232.7s.1.07.27.14a1,1,0,0,0,.75,0,2.47,2.47,0,0,0,1.12-2.22,3.3,3.3,0,0,0-.3-1.43,1.13,1.13,0,0,0-.75-.75.51.51,0,0,0-.59.27c-.07.17,0,.28-.07.29s-.12-.1-.08-.33a.63.63,0,0,1,.23-.36.71.71,0,0,1,.55-.15,1.4,1.4,0,0,1,1.05.87,3.43,3.43,0,0,1,.36,1.6,2.6,2.6,0,0,1-1.43,2.48,1.09,1.09,0,0,1-.92-.14C156.14,232.84,156.11,232.71,156.13,232.7Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.65,223.93a2.18,2.18,0,0,1-.34-.2,10.93,10.93,0,0,1-1-.61,19.1,19.1,0,0,1-3.09-2.81,55.88,55.88,0,0,1-3.78-4.9,45,45,0,0,0-4.72-5.88,17.18,17.18,0,0,0-3-2.41,14.8,14.8,0,0,0-3.29-1.49,16.27,16.27,0,0,0-6.06-.75,15.43,15.43,0,0,0-4.06.8c-.47.14-.82.3-1.06.39a1.59,1.59,0,0,1-.37.13l.35-.18c.24-.1.58-.28,1-.44a14.88,14.88,0,0,1,4.08-.88,16.05,16.05,0,0,1,6.15.7,15.47,15.47,0,0,1,3.35,1.5,18.1,18.1,0,0,1,3.09,2.44,43.63,43.63,0,0,1,4.74,5.93,56.86,56.86,0,0,0,3.72,4.92,21,21,0,0,0,3,2.85c.39.3.71.5.92.65A1.54,1.54,0,0,1,156.65,223.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.78,233.71a1.12,1.12,0,1,1-.26.08",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.52,233.79a1.55,1.55,0,0,0-.52.77,1,1,0,0,0,.22.9,1,1,0,0,0,1.76-.56,1,1,0,0,0-.33-.86,1.61,1.61,0,0,0-.87-.33.42.42,0,0,1,.27-.06,1.19,1.19,0,0,1,1.17,1.28,1.22,1.22,0,0,1-2.17.69,1.17,1.17,0,0,1,.21-1.72C156.41,233.8,156.51,233.78,156.52,233.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.21,225.55a8.83,8.83,0,0,1-.56,4.6c-.72,1.39-2.54,2.33-3.9,1.55-1.11-.63-1.44-2-1.63-3.31-.54-3.65-.79-7.33-1.36-11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.24,206.47s.5-.1,1.42-.13a10,10,0,0,1,3.79.69,12.74,12.74,0,0,1,2.37,1.22,27.08,27.08,0,0,1,2.45,1.87,29.6,29.6,0,0,1,4.79,5.17c.72,1,1.37,2.07,2.06,3a15.12,15.12,0,0,0,2.3,2.58,25.69,25.69,0,0,0,4.83,3.23c1.47.78,2.69,1.32,3.53,1.69l1,.42a1.7,1.7,0,0,0,.35.12,1.31,1.31,0,0,0-.32-.18l-.95-.47c-.83-.41-2-1-3.48-1.78a26.72,26.72,0,0,1-4.75-3.25,14.92,14.92,0,0,1-2.23-2.54c-.68-1-1.33-2-2.06-3.05a28.7,28.7,0,0,0-4.86-5.2A23.53,23.53,0,0,0,134,208a12.49,12.49,0,0,0-2.43-1.21,9.34,9.34,0,0,0-3.87-.6,7.45,7.45,0,0,0-1.06.14A1.62,1.62,0,0,0,126.24,206.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.37,222a2.19,2.19,0,0,0,.51.34l1.44.85.49.28a1.57,1.57,0,0,0,.63.21.58.58,0,0,0,.39-.09.51.51,0,0,0,.21-.38,1.28,1.28,0,0,0-.27-.72l-1.68-2.69-.23.21a5.86,5.86,0,0,0,1.84.91,5.8,5.8,0,0,0,2.05.25,2,2,0,0,0,.52-.09.73.73,0,0,0,.44-.39.59.59,0,0,0-.1-.58,2.91,2.91,0,0,0-.32-.36,11.93,11.93,0,0,1-1.95-2.45,20.2,20.2,0,0,1-1.24-2.64,2.79,2.79,0,0,0,.18.77,11.46,11.46,0,0,0,.86,2,11.84,11.84,0,0,0,1.94,2.56c.21.2.43.43.34.61s-.39.27-.69.27a5.93,5.93,0,0,1-1.94-.23,5.57,5.57,0,0,1-1.74-.87l-.68-.49.45.71,1.72,2.67a1,1,0,0,1,.24.55.28.28,0,0,1-.33.25,3.07,3.07,0,0,1-1-.42l-1.49-.77A2.79,2.79,0,0,0,155.37,222Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.45,237.26a1.9,1.9,0,0,0-2-1.45,2,2,0,0,0-1.54,1.09,2.46,2.46,0,0,0-.09,1.92l0,.13a2.17,2.17,0,0,0,2.45.53A2,2,0,0,0,138.45,237.26Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.82,239c0-.23,1.48-.16,2.6-1.37s1-2.8,1.23-2.81.27.37.26,1a3.7,3.7,0,0,1-.95,2.34,3.21,3.21,0,0,1-2.17,1.05C134.17,239.27,133.81,239.09,133.82,239Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.23,352.59c1.33-6.89,5.6-30.08,5.6-34.77,0-.77-1.2-3.18-1.42-3.93-1.25-4.18-5.59-19.58-4.62-27.7.78-6.49,6.27-14.79,7.92-19.23.77-2.09,6.94-4.24,9-5.1l4.37-6.17s-1,2.87,2.91,5.45a11.74,11.74,0,0,0,7,1.86,17.91,17.91,0,0,0,12.86-6.33l.72.56c14.12,4.55,14,4.58,16.68,5.72,3.49,1.47-7.57,37.29-7.57,37.29s-6.53,24.19-3,31.69c2,4.22,8.66,11.19,10.35,15.11,0,0,2.94,4.11,3,5.14s-17.39,8.59-31.16,9.36C118.43,363,111.23,352.59,111.23,352.59Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.13,
    y: 415.47,
    width: 111.94,
    height: 29.15,
    rx: 3.76,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.51,
    y: 422.43,
    width: 49.64,
    height: 16.46,
    rx: 0.71,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.65,
    cy: 430.66,
    r: 5.96,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.65,437.62a7,7,0,1,1,7-7A7,7,0,0,1,134.65,437.62Zm0-11.92a5,5,0,1,0,5,5A5,5,0,0,0,134.65,425.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.7,425.24a58.73,58.73,0,0,1,0,11,58.73,58.73,0,0,1,0-11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.53,425.24a58.73,58.73,0,0,1,0,11,58.73,58.73,0,0,1,0-11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.36,425.24a58.73,58.73,0,0,1,0,11,58.73,58.73,0,0,1,0-11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.19,425.24a58.73,58.73,0,0,1,0,11,58.73,58.73,0,0,1,0-11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,425.24a58.73,58.73,0,0,1,0,11,58.73,58.73,0,0,1,0-11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.85,425.24a58.73,58.73,0,0,1,0,11,58.73,58.73,0,0,1,0-11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.68,425.24a58.73,58.73,0,0,1,0,11,58.73,58.73,0,0,1,0-11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.5,425.24a58.73,58.73,0,0,1,0,11,58.73,58.73,0,0,1,0-11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.33,425.24a58.73,58.73,0,0,1,0,11,58.73,58.73,0,0,1,0-11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.13,
    y: 387.41,
    width: 111.94,
    height: 29.15,
    rx: 3.76,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.51,
    y: 394.36,
    width: 49.64,
    height: 16.46,
    rx: 0.71,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.65,
    cy: 402.59,
    r: 5.96,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.65,409.55a7,7,0,1,1,7-7A7,7,0,0,1,134.65,409.55Zm0-11.91a5,5,0,1,0,5,4.95A5,5,0,0,0,134.65,397.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.7,397.18a58.62,58.62,0,0,1,0,11,58.62,58.62,0,0,1,0-11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.53,397.18a58.62,58.62,0,0,1,0,11,58.62,58.62,0,0,1,0-11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.36,397.18a58.62,58.62,0,0,1,0,11,58.62,58.62,0,0,1,0-11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.19,397.18a58.62,58.62,0,0,1,0,11,58.62,58.62,0,0,1,0-11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,397.18a58.62,58.62,0,0,1,0,11,58.62,58.62,0,0,1,0-11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.85,397.18a58.62,58.62,0,0,1,0,11,58.62,58.62,0,0,1,0-11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.68,397.18a58.62,58.62,0,0,1,0,11,58.62,58.62,0,0,1,0-11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.5,397.18a58.62,58.62,0,0,1,0,11,58.62,58.62,0,0,1,0-11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.33,397.18a58.62,58.62,0,0,1,0,11,58.62,58.62,0,0,1,0-11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.13,
    y: 444.78,
    width: 111.94,
    height: 29.15,
    rx: 3.76,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.51,
    y: 451.74,
    width: 49.64,
    height: 16.46,
    rx: 0.71,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.61,460a6,6,0,1,0-6,6A6,6,0,0,0,140.61,460Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.65,466.93a7,7,0,1,1,7-7A7,7,0,0,1,134.65,466.93Zm0-11.92a5,5,0,1,0,5,5A5,5,0,0,0,134.65,455Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.7,454.55a58.62,58.62,0,0,1,0,11,58.62,58.62,0,0,1,0-11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.53,454.55a58.62,58.62,0,0,1,0,11,58.62,58.62,0,0,1,0-11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.36,454.55a58.62,58.62,0,0,1,0,11,58.62,58.62,0,0,1,0-11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.19,454.55a58.62,58.62,0,0,1,0,11,58.62,58.62,0,0,1,0-11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,454.55a58.62,58.62,0,0,1,0,11,58.62,58.62,0,0,1,0-11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.85,454.55a58.62,58.62,0,0,1,0,11,58.62,58.62,0,0,1,0-11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.68,454.55a58.62,58.62,0,0,1,0,11,58.62,58.62,0,0,1,0-11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.5,454.55a58.62,58.62,0,0,1,0,11,58.62,58.62,0,0,1,0-11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.33,454.55a58.62,58.62,0,0,1,0,11,58.62,58.62,0,0,1,0-11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.43,415.12,47.14,433s-20.7-2.74-22.56.42l33.85,17.64,14.06-27.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.18,436.84a1.59,1.59,0,0,1,.16,2.1,1.52,1.52,0,0,1-2.08.17,1.66,1.66,0,0,1-.15-2.22,1.57,1.57,0,0,1,2.17.06",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.43,451.08l1.12-2.18L26.36,432.44a2.9,2.9,0,0,0-2,1.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.77,433c-.08.17.72.68,1.27,1.63s.64,1.89.82,1.9.43-1.08-.25-2.23S46.81,432.8,46.77,433Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.41,432.63c-.12.15.46.8.67,1.8s0,1.83.16,1.91.76-.82.48-2S42.49,432.48,42.41,432.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.17,435.91c.14.11.8-.61.83-1.75s-.56-1.9-.7-1.79.09.84.05,1.77S38,435.81,38.17,435.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.13,429.08c0,.19.88.34,1.8.89s1.5,1.22,1.66,1.12-.25-1.06-1.34-1.69S49.11,428.9,49.13,429.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.44,425c0,.07.57.51,1.73.87a9.41,9.41,0,0,0,2.08.36,8.8,8.8,0,0,0,1.25,0,2.44,2.44,0,0,0,.73-.14.83.83,0,0,0,.53-.85,1.08,1.08,0,0,0-.54-.76,2.77,2.77,0,0,0-.7-.24,6.94,6.94,0,0,0-1.25-.17,6.82,6.82,0,0,0-2.12.23c-1.17.34-1.76.83-1.72.89s.7-.24,1.82-.43a7.79,7.79,0,0,1,2-.09,6.83,6.83,0,0,1,1.14.2c.41.09.72.24.74.45s0,.11-.14.17a1.78,1.78,0,0,1-.53.1,7.91,7.91,0,0,1-1.17.06,10.27,10.27,0,0,1-2-.2A13.65,13.65,0,0,0,50.44,425Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.63,443.88l1.05,19.69S69.11,470.84,69,474.5l38.16-.25-.37-30.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.23,461.79a1.57,1.57,0,0,1,1.12,1.77,1.51,1.51,0,0,1-1.75,1.13,1.66,1.66,0,0,1-1.18-1.89,1.57,1.57,0,0,1,2-1",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.11,474.25l0-2.45-37,1a2.88,2.88,0,0,0-1.28,1.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.33,463.71c0,.18,1,.25,1.89.84s1.45,1.37,1.62,1.3-.13-1.16-1.28-1.86S88.29,463.53,88.33,463.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.32,465.45c0,.18.78.49,1.44,1.27s.85,1.62,1,1.61.29-1.08-.54-2S84.32,465.27,84.32,465.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.11,470.32c.17,0,.42-.9-.08-1.93s-1.39-1.41-1.47-1.25.48.69.88,1.54S81.92,470.31,82.11,470.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6,459.16c.08.17.94-.11,2-.05s1.9.37,2,.21-.72-.82-2-.87S88.5,459,88.6,459.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.84,454.92a3.5,3.5,0,0,0,1.93,0,8.71,8.71,0,0,0,2-.65,8,8,0,0,0,1.1-.61,2.53,2.53,0,0,0,.58-.46.85.85,0,0,0,.07-1,1.05,1.05,0,0,0-.84-.41,2.22,2.22,0,0,0-.72.11,7.28,7.28,0,0,0-1.19.43,6.85,6.85,0,0,0-1.76,1.2c-.88.84-1.17,1.55-1.11,1.59s.51-.54,1.41-1.24a7.56,7.56,0,0,1,1.71-1,8.34,8.34,0,0,1,1.1-.36c.4-.11.75-.12.86.06s0,.09,0,.22a1.92,1.92,0,0,1-.42.33,9.9,9.9,0,0,1-1,.6,10.41,10.41,0,0,1-1.85.75A14.22,14.22,0,0,0,87.84,454.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.91,349.33s-78.15-9.26-82.65-9.26c-10.58,0-15.54,7.75-17.12,14-1.17,4.6-24.71,71.1-24.71,71.1l17.37,9,25.53-45.38,13-22.64,67.07,10.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.19,364s-10.48,0-16.14,8.38c-3.33,4.93-2.16,13.74-2.23,20.39-.09,9.05,2.1,64.19,2.1,64.19l21.44.35,4.49-57.46-.27-10.63,42.8-3.48s3.9-13-5.68-23.21C148.46,361.24,103.19,364,103.19,364Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.89,350.4s6.67,15.41-2.34,28.6c-6,8.7-17.37,6.71-17.37,6.71l-15.16-19,12.1-18.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.92,457a1.59,1.59,0,0,1,.38,0h1.11l4.27,0,15.68.17-.19.18c.83-11.54,1.94-27.06,3.17-44.11.41-5.55.81-10.94,1.19-16.06v0q-.11-4.08-.19-7.92V389l.23,0c12.17-1,22.54-1.85,29.86-2.52,3.67-.34,6.57-.61,8.55-.83,1-.1,1.75-.22,2.27-.28a7.64,7.64,0,0,1,.77-.14,5.94,5.94,0,0,1-.76.22c-.51.09-1.27.23-2.26.35-2,.28-4.88.6-8.54,1-7.32.76-17.69,1.7-29.85,2.72l.22-.25q.11,3.84.21,7.92h0v0c-.37,5.12-.77,10.51-1.17,16.06-1.28,17-2.45,32.56-3.31,44.1l0,.18h-.18l-15.67-.35-4.27-.12L87.3,457Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.18,385.71s-.09-.06-.28-.15l-.85-.4-3.3-1.49-12.17-5.42-18.06-8-10.67-4.7c-.93-.4-1.83-.85-2.83-1.19a17.38,17.38,0,0,0-3-.78,23.16,23.16,0,0,0-6.39-.06,20.13,20.13,0,0,0-6.15,1.75A10.62,10.62,0,0,0,88.79,367a9.66,9.66,0,0,0-1.94,2.43,13.71,13.71,0,0,0-1.79,5.72c-.08,1,0,1.95,0,2.9s0,1.9,0,2.83c.09,7.42.16,14.12.23,19.74s.14,10.15.19,13.32c0,1.55,0,2.76.07,3.62l0,.94a1.34,1.34,0,0,0,0,.32s0-.11,0-.32,0-.55,0-.95c0-.85,0-2.06,0-3.62,0-3.16,0-7.71-.06-13.31s-.08-12.32-.13-19.75c0-.92,0-1.86,0-2.82s0-1.92,0-2.86a13.4,13.4,0,0,1,1.74-5.55,9.54,9.54,0,0,1,1.87-2.33,10.6,10.6,0,0,1,2.54-1.66,20,20,0,0,1,6-1.7,22.68,22.68,0,0,1,6.27.05,16.37,16.37,0,0,1,3,.76c1,.32,1.88.79,2.81,1.18l10.68,4.67,18.09,7.91,12.22,5.29,3.33,1.42.87.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.51,308.76a6.71,6.71,0,0,0-.17-1.25c-.14-.79-.31-1.95-.47-3.39s-.27-3.15-.3-5.06A49.11,49.11,0,0,1,117,286.75a47.69,47.69,0,0,1,1.46-4.86c.48-1.36.92-2.45,1.24-3.19a6.44,6.44,0,0,0,.45-1.18,7.72,7.72,0,0,0-.6,1.11c-.37.72-.85,1.8-1.38,3.16a46.89,46.89,0,0,0-1.56,4.86,45.88,45.88,0,0,0-1.45,12.41,43.92,43.92,0,0,0,.4,5.1,33.71,33.71,0,0,0,.61,3.39A6.11,6.11,0,0,0,116.51,308.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.08,255.69l0-3.16-3.7,6-7.56,2.79c-2.37,2.73-10.06,33.53-8.5,38.62L115,330.09l-7.65,11.52L121,343.08s2.95-2.92,2.22-10.63c-1.87-19.53.06-41.82.34-46.75C124,278.27,132.08,255.69,132.08,255.69Z",
    style: {
      fill: "#09AD58"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.34,258.57s-12.4,4.06-14,6.39c-4.42,6.35-31,49.77-18,62.73,8.55,8.48,20.56-9.42,20.56-9.42Z",
    style: {
      fill: "#09AD58"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98,310.43a6.51,6.51,0,0,0,1.13-.2l3.09-.66c2.62-.56,6.3-1.34,10.52-2l-.22-.13c.4,1,.83,2.13,1.26,3.24,1.08,2.75,2.11,5.35,3,7.63l0-.19L112.11,324l-1.29,1.66a3.12,3.12,0,0,0-.43.62,3.59,3.59,0,0,0,.52-.54l1.38-1.6,4.78-5.72.07-.08,0-.11c-.88-2.29-1.89-4.89-3-7.64-.44-1.11-.86-2.2-1.27-3.24l-.06-.16-.17,0c-4.24.66-7.91,1.49-10.52,2.12-1.31.31-2.35.59-3.07.79A6.4,6.4,0,0,0,98,310.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.7,307a10.66,10.66,0,0,0-.13-1.38c-.12-1-.27-2.23-.46-3.76a59.8,59.8,0,0,1-.41-12.42,34.09,34.09,0,0,1,3.43-11.87c.7-1.44,1.33-2.57,1.77-3.34a9.15,9.15,0,0,0,.66-1.23,1.44,1.44,0,0,0-.22.28c-.14.2-.34.48-.58.86-.49.75-1.16,1.86-1.9,3.29a32.57,32.57,0,0,0-3.59,12,53.74,53.74,0,0,0,.54,12.5c.22,1.58.44,2.86.59,3.74A7.67,7.67,0,0,0,110.7,307Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.86,301.79a1.59,1.59,0,0,0,0-.5c0-.37-.07-.84-.11-1.42-.11-1.28-.27-3.05-.46-5.21s-.47-4.83-.75-7.73c-.14-1.45-.29-3-.45-4.56A15.89,15.89,0,0,1,120,280a4.46,4.46,0,0,1,.65-2.26,2.58,2.58,0,0,1,2.19-1.26l.78,0-.65-.43-3.26-2.2.06.27,6.37-10.92,1.81-3.19.47-.86a1.35,1.35,0,0,0,.14-.31,1.46,1.46,0,0,0-.2.28c-.15.22-.32.49-.53.82l-1.92,3.13-6.49,10.84-.1.17.16.11,3.25,2.21.13-.39a3,3,0,0,0-2.57,1.46,4.84,4.84,0,0,0-.72,2.47,17.74,17.74,0,0,0,.14,2.45c.17,1.58.33,3.11.48,4.56.31,2.89.6,5.51.84,7.72s.45,3.92.6,5.2c.07.58.13,1,.18,1.41A3.43,3.43,0,0,0,121.86,301.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.55,253.27l3.7,4L171,261.61a244.72,244.72,0,0,1-3.25,30.12c-3,17-4.66,34.25-4.75,34.52-.66-1.26,6.92,9.15,11.1,19.37,3.3,8,5.1,24.8,5.1,24.8L144.58,381l-5.86-62.76,1.52-29Z",
    style: {
      fill: "#09AD58"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.25,304.78a3.15,3.15,0,0,0,.26-.52l.67-1.51c.58-1.31,1.43-3.22,2.52-5.54a197.36,197.36,0,0,1,9.4-17.72l1-1.57.13-.21-.23-.1-3.9-1.61,0,.36a10.63,10.63,0,0,1,4.33-2.18l.14,0V274a49.54,49.54,0,0,1,1.22-6.88c.48-2.05.9-3.86,1.14-5.38a26,26,0,0,0,.35-3.57c0-.42,0-.74,0-.95a1.39,1.39,0,0,0,0-.33,11,11,0,0,0-.09,1.28,29.49,29.49,0,0,1-.46,3.53c-.27,1.5-.71,3.3-1.22,5.35a45.75,45.75,0,0,0-1.29,6.92l.15-.18a11,11,0,0,0-4.5,2.24l-.27.23.32.13,3.9,1.62-.11-.31-1,1.57a175.3,175.3,0,0,0-9.31,17.81c-1,2.35-1.86,4.27-2.39,5.6l-.6,1.55A3.53,3.53,0,0,0,140.25,304.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.67,347.82a2.74,2.74,0,0,0,.31.43l.91,1.15,3.39,4.14.09-.25-16.45,3.09.22.09c-.09-.11-.18-.24-.26-.36l-4.59-6.39-.14.32L164,348.51l3.44-.48.92-.14.33-.07s-.1,0-.31,0l-.9.08-3.42.36-11.94,1.38-.34,0,.2.28,4.57,6.4c.09.12.17.25.26.36l.08.11.13,0,16.42-3.22.26,0-.17-.2L170,349.25l-1-1.09C168.79,347.92,168.67,347.8,168.67,347.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "171.28 353.85 172.37 355.97 156.94 359.29 153.08 351.18 156.96 356.6 171.28 353.85"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M56.33,303.85l8.45,41.45h73.28a1.46,1.46,0,0,0,1.46-1.46h0a1.46,1.46,0,0,0-1.46-1.47H123.31l-7.83-38.54a1.61,1.61,0,0,0-1.55-1.29l-56-.61A1.6,1.6,0,0,0,56.33,303.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.33,303.85a1.13,1.13,0,0,1,0-.12,2.13,2.13,0,0,1,0-.38,1.62,1.62,0,0,1,.78-1.21,1.46,1.46,0,0,1,.48-.19,2.74,2.74,0,0,1,.58,0h1.32l3.3,0,21.17.2,14.77.15,8.27.08,4.34.05,2.21,0c.19,0,.37,0,.57,0a1.62,1.62,0,0,1,.57.16,1.72,1.72,0,0,1,.8.84,2.53,2.53,0,0,1,.15.57l.12.55c.07.38.15.75.23,1.12.15.75.3,1.51.46,2.27.3,1.52.62,3,.93,4.61.64,3.11,1.28,6.29,2,9.54,1.32,6.5,2.69,13.26,4.11,20.22l-.1-.08h14.51a2.28,2.28,0,0,1,.57,0,1.56,1.56,0,0,1,.42,2.9,1.55,1.55,0,0,1-.69.19H99.19l-34.41,0h-.07v-.06C62.12,332.58,60,322.21,58.57,315c-.72-3.59-1.29-6.38-1.67-8.28-.19-.95-.33-1.67-.43-2.16s-.14-.74-.14-.74.06.25.17.74.25,1.21.45,2.15c.39,1.9,1,4.69,1.7,8.27l6.2,30.28-.07-.07h73.33a1.53,1.53,0,0,0,.6-.16,1.38,1.38,0,0,0,.7-1,1.36,1.36,0,0,0-.23-1,1.31,1.31,0,0,0-.84-.55,2.21,2.21,0,0,0-.52,0H123.23l0-.08-4.1-20.22q-1-4.87-1.94-9.55c-.31-1.55-.62-3.09-.93-4.61-.16-.76-.31-1.51-.46-2.26l-.23-1.12-.11-.56a2.94,2.94,0,0,0-.14-.53,1.53,1.53,0,0,0-1.23-.9h-.55l-2.22,0-4.33-.05-8.27-.09-14.77-.18L62.76,302l-3.3,0-1.32,0a2.14,2.14,0,0,0-.57,0,1.76,1.76,0,0,0-.47.18,1.64,1.64,0,0,0-.78,1.18A3.8,3.8,0,0,0,56.33,303.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87.68,
    cy: 322.82,
    r: 2.42,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4,304.19h3.85l10.47.05,34.57.24,5,0h1.23a3.44,3.44,0,0,1,.63,0,1.79,1.79,0,0,1,.59.24,1.73,1.73,0,0,1,.75,1c.09.41.16.79.24,1.18.62,3.13,1.21,6.14,1.78,9,1.14,5.73,2.16,10.9,3,15.24s1.53,7.85,2,10.29c.23,1.21.42,2.15.54,2.79.06.32.1.56.13.73s0,.25,0,.25l-.06-.24c0-.17-.08-.41-.15-.73-.13-.64-.33-1.58-.58-2.79-.49-2.43-1.2-5.94-2.07-10.27s-1.91-9.5-3.06-15.24c-.57-2.87-1.17-5.88-1.8-9-.08-.38-.15-.79-.24-1.17a1.5,1.5,0,0,0-.65-.89,1.63,1.63,0,0,0-.53-.21,3.65,3.65,0,0,0-.59,0h-1.23l-5,0-34.57-.31-10.48-.11-2.84,0-.75,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.06,322.53l0,0Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.2,322.62l.05,0Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.08,322.55l.12.07Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,322.5l.06,0Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.59,332.9c1.36-2,10.7-6.48,10.7-6.48L126,325.6l-2.72.79a6.44,6.44,0,0,1-1.41,2.3c-1.11,1.24-2.57-.36-2.57-.36l1.72-5.12,5.51-2.48A51.17,51.17,0,0,1,132,322.5l1.84,2.13c.82.81,3.1,3.92,3.8,4.09.22,0,6.71-2.07,6.71-2.07l2.68,11.9-9.9.85-6,.92a40.32,40.32,0,0,1-5,1.08c-2,.18-3.22-.6-3.14-1.68s1.59-1,1.59-1a29.3,29.3,0,0,0,4-1.2,6.65,6.65,0,0,0,2.39-2.07H128.8s-4.78,2.54-6.55,3.25-1.9-1-2-1.51,5.61-4.9,5.61-4.9-5.2,2.41-6.16,3.06-2.28.73-2.5.19S116.23,334.87,117.59,332.9Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.25,322.66l.05,0Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.32,322.7Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.3,322.69h0Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.44,336.22s0-.12.07-.34a2.36,2.36,0,0,0,0-.4,3.32,3.32,0,0,0,0-.53,7.57,7.57,0,0,0-1.09-2.89,16.25,16.25,0,0,0-1.86-2.45,5.89,5.89,0,0,0-.91-.89,12.63,12.63,0,0,0,.8,1,19.34,19.34,0,0,1,1.79,2.46,8,8,0,0,1,1.12,2.8A11.77,11.77,0,0,1,141.44,336.22Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.51,326.28a2.51,2.51,0,0,0,1.5,0,2.46,2.46,0,0,0,1.35-.64c0-.05-.61.28-1.39.44S128.52,326.22,128.51,326.28Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.38,331.86a12.33,12.33,0,0,0,2.31-.54,14.1,14.1,0,0,0,2.25-.73,14.57,14.57,0,0,0-2.31.54A15,15,0,0,0,126.38,331.86Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.69,335.35a15.89,15.89,0,0,0,2.34-.61,3,3,0,0,0-1.21.15A3,3,0,0,0,130.69,335.35Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.05,332.33a4.11,4.11,0,0,1,.77.85,4.59,4.59,0,0,1,.37,1.08s.07-.13.06-.35a1.85,1.85,0,0,0-.86-1.46C127.2,332.34,127.06,332.31,127.05,332.33Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.4,328.88c0,.05.32.3.52.77a5.55,5.55,0,0,1,.21.9,1,1,0,0,0,0-1C125.87,329,125.41,328.82,125.4,328.88Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.77,323.22s.11-.07.19-.25a1.38,1.38,0,0,0,.11-.77,1.41,1.41,0,0,0-.29-.71c-.12-.16-.23-.22-.24-.2a4.32,4.32,0,0,1,.33.94A4.52,4.52,0,0,1,126.77,323.22Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,261.61a14.59,14.59,0,0,1,8.2,9.66s1.46,4.54,2.56,9.62c2.65,12.34,7.41,33.37,7.63,39.51.42,11.11-7.62,14.27-12.13,15.24s-32.49,4.43-32.49,4.43l-4.9-13.82,28.53-12.42s-5.44-18.68-6.7-24.52",
    style: {
      fill: "#09AD58"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.71,289.31s0,.15.13.43.18.73.32,1.26c.3,1.14.74,2.77,1.3,4.86,1.16,4.22,2.9,10.34,5.12,17.92l0,.15-.14.06L140,326.47l.13-.3q2.35,6.65,4.9,13.82l-.27-.17c7.28-.91,15-1.9,23-3,3.22-.46,6.43-.87,9.52-1.46a16.5,16.5,0,0,0,8.11-4.12,12.79,12.79,0,0,0,3.65-7.9c0-.36.09-.72.11-1.08v-1.09a19.23,19.23,0,0,0-.09-2.15c-.16-1.43-.35-2.84-.58-4.24-.91-5.56-2-10.82-3-15.73s-2-9.49-2.9-13.67c-.45-2.08-.88-4.07-1.29-5.95s-.88-3.63-1.34-5.26-.9-3.15-1.37-4.51a13.5,13.5,0,0,0-1.89-3.44,15.1,15.1,0,0,0-4-3.7c-.53-.33-1-.56-1.24-.71a2.77,2.77,0,0,1-.43-.22,2.65,2.65,0,0,1,.45.18,11.51,11.51,0,0,1,1.27.66,14.89,14.89,0,0,1,4.1,3.66,13.71,13.71,0,0,1,2,3.48c.5,1.38.94,2.89,1.42,4.52s.94,3.39,1.39,5.26.85,3.87,1.32,6c.9,4.17,1.9,8.74,3,13.65S188,309.15,189,314.73c.23,1.39.44,2.81.6,4.26a20.13,20.13,0,0,1,.09,2.2v1.11c0,.37-.07.75-.11,1.12a13.24,13.24,0,0,1-3.78,8.2,16.85,16.85,0,0,1-8.36,4.26c-3.15.6-6.33,1-9.56,1.47-8,1.09-15.74,2.07-23,3l-.21,0-.06-.19-4.88-13.83-.08-.21.21-.09,28.55-12.36-.1.21c-2.17-7.6-3.86-13.73-5-18-.54-2.12-1-3.76-1.21-4.88-.13-.56-.21-1-.27-1.28S161.71,289.31,161.71,289.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.53,284a3,3,0,0,1-.16-.9,18.13,18.13,0,0,1-.11-2.47,26.23,26.23,0,0,1,5.21-15.29,18.1,18.1,0,0,1,1.61-1.89c.41-.42.64-.64.67-.61s-.8,1-2,2.71a30.29,30.29,0,0,0-3.61,7.19,29.94,29.94,0,0,0-1.54,7.9C160.51,282.74,160.62,284,160.53,284Z",
    style: {
      fill: "#263238"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomepageimg);
export default __webpack_public_path__ + "static/media/homepageimg.d16ae07310bf999f94d2b4df43865ba1.svg";
export { ForwardRef as ReactComponent };